{
  "app": {
    "name": "Tridi",
    "loading": "Memuat…"
  },
  "login": {
    "title": "Masuk ke Tridi",
    "subtitle": "Masukkan email Anda. Kalau email itu diundang, kami kirimkan tautan masuk.",
    "emailLabel": "Email",
    "emailPlaceholder": "nama@contoh.com",
    "submit": "Kirim tautan masuk",
    "submitting": "Mengirim…",
    "sent": "Kalau email itu diundang, tautan masuk sudah dikirim. Silakan cek kotak masuk Anda.",
    "invalidEmail": "Masukkan alamat email yang benar.",
    "rateLimited": "Terlalu banyak permintaan. Coba lagi nanti.",
    "failed": "Gangguan sementara. Coba lagi nanti.",
    "magicLinkInvalid": "Tautan masuk sudah dipakai atau kedaluwarsa. Silakan minta tautan baru.",
    "invitationInvalid": "Undangan sudah dipakai atau kedaluwarsa. Minta undangan baru ke pemilik workspace.",
    "googleSubmit": "Masuk dengan Google",
    "or": "atau",
    "googleNotInvited": "Akun Google ini belum diundang ke Tridi. Minta undangan ke pemilik workspace.",
    "googleFailed": "Masuk dengan Google gagal. Silakan coba lagi.",
    "noAccess": "Belum punya akses?",
    "requestAccess": "Minta akses"
  },
  "signUp": {
    "title": "Minta akses ke Tridi",
    "subtitle": "Ceritakan sedikit tentang usaha Anda. Tim kami akan meninjau permintaan ini dan mengabari Anda lewat email.",
    "nameLabel": "Nama Anda",
    "emailLabel": "Email",
    "emailPlaceholder": "nama@contoh.com",
    "businessNameLabel": "Nama usaha",
    "noteLabel": "Apa yang Anda cetak? (opsional)",
    "notePlaceholder": "Misalnya: figur, mainan, suku cadang",
    "submit": "Kirim permintaan",
    "submitting": "Mengirim…",
    "received": "Terima kasih! Permintaan Anda sudah kami terima. Tim kami akan mengabari Anda lewat email setelah meninjaunya.",
    "required": "Wajib diisi.",
    "invalidEmail": "Masukkan alamat email yang benar.",
    "invalidField": "Periksa kembali isian ini.",
    "failed": "Gangguan sementara. Coba lagi nanti.",
    "haveAccess": "Sudah punya akses?",
    "signIn": "Masuk"
  },
  "ui": {
    "close": "Tutup",
    "more": "Lainnya",
    "breadcrumb": "Lokasi halaman"
  },
  "shell": {
    "searchPlaceholder": "Cari…",
    "search": {
      "title": "Pencarian",
      "description": "Cari stok bahan, produk (kode atau nama), varian (SKU, nama, atau nama produknya), kanal penjualan, atau batch cetak (nomor, mis. B-0012).",
      "placeholder": "Cari stok bahan, produk, varian, kanal, nomor batch…",
      "hint": "Ketik untuk mencari.",
      "loading": "Mencari…",
      "empty": "Tidak ada hasil.",
      "error": "Pencarian gagal. Coba lagi.",
      "pools": "Stok bahan",
      "products": "Produk",
      "variants": "Varian",
      "salesChannels": "Kanal penjualan",
      "shortcut": "⌘K",
      "batches": "Batch cetak"
    },
    "workspaceMenu": "Workspace saat ini: {{name}}",
    "switchWorkspace": "Ganti workspace",
    "account": "Akun",
    "logout": "Keluar",
    "loggingOut": "Keluar…",
    "logoutFailed": "Gagal keluar. Coba lagi.",
    "toggleSidebar": "Buka atau tutup menu",
    "sidebarTitle": "Menu",
    "sidebarDescription": "Navigasi utama workspace."
  },
  "nav": {
    "overview": "Ringkasan",
    "production": "Produksi",
    "stock": "Stok",
    "catalog": "Katalog",
    "sales": "Penjualan",
    "settings": "Pengaturan",
    "money": "Keuangan"
  },
  "workspacePicker": {
    "title": "Pilih workspace",
    "subtitle": "Anda punya akses ke beberapa workspace."
  },
  "dashboard": {
    "title": "Beranda",
    "emptyTitle": "Belum ada yang ditampilkan",
    "emptyBody": "Ringkasan mesin, stok bahan, dan varian yang bisa dirakit muncul di sini setelah Anda mulai mencatat produksi.",
    "materials": {
      "title": "Stok bahan perlu perhatian",
      "seeAll": "Lihat semua ({{count}})",
      "ofMinimum": "{{qty}} dari minimum {{min}}"
    },
    "machines": {
      "title": "Mesin",
      "idle": "Siap",
      "printing": "Sedang mencetak {{batchNo}}",
      "estimate": "Perkiraan",
      "progress": "{{elapsed}} dari {{total}}",
      "progressLabel": "Perkiraan kemajuan {{batchNo}}",
      "printingStatus": "Mencetak",
      "summary": "{{printing}} dari {{total}} sedang mencetak"
    },
    "readyToAssemble": {
      "title": "Bisa dirakit",
      "buildable": "Bisa dirakit: {{count}}",
      "needsColor": "Perlu warna"
    },
    "thisMonth": {
      "title": "Bulan ini",
      "paymentsReceived": "Pembayaran diterima",
      "expenses": "Pengeluaran",
      "netCash": "Kas bersih",
      "seeSummary": "Lihat ringkasan bulanan"
    },
    "unpaidSettlements": {
      "title": "Sisa tagihan per kanal penjualan",
      "seeAll": "Lihat semua ({{count}})"
    },
    "overdueChannels": {
      "title": "Kanal penjualan telat lapor",
      "daysOverdue": "Telat {{count}} hari",
      "lastPeriodEnd": "Laporan terakhir sampai {{date}}",
      "neverReported": "Belum pernah ada laporan sejak {{date}}",
      "cycle": "Siklus laporan {{count}} hari"
    }
  },
  "guide": {
    "title": "Panduan",
    "intro": "Cara kerja Tridi dari bahan sampai HPP: alurnya, siapa yang mengerjakan tiap langkah, dan di layar mana.",
    "showChecklist": "Tampilkan daftar persiapan",
    "who": "Siapa:",
    "screens": "Layar:",
    "ownerOnly": "(Pemilik)",
    "flow": {
      "title": "Alur stok",
      "description": "Stok bergerak dari bahan sampai terjual. Setiap langkah mencatat mutasi stok, jadi angka stok dan HPP selalu berasal dari catatan nyata.",
      "aside": "Di samping alur",
      "nodes": {
        "pools": "Stok bahan",
        "batch": "Batch cetak",
        "wip": "Part belum dirakit (WIP)",
        "assembly": "Perakitan",
        "finishedGoods": "Barang jadi (Gudang)",
        "dispatch": "Pengiriman",
        "channelStock": "Stok di kanal",
        "salesReport": "Laporan penjualan",
        "payment": "Pembayaran",
        "expenses": "Pengeluaran",
        "cogs": "HPP"
      },
      "asideNotes": {
        "expenses": "Semua uang keluar, termasuk belanja bahan.",
        "cogs": "Dihitung otomatis dari batch, perakitan, dan tarif mesin."
      }
    },
    "setup": {
      "title": "Sebelum mulai",
      "intro": "Siapkan data dasar ini dulu. Urutannya hanya panduan; tidak ada layar yang dikunci.",
      "tracks": {
        "fromScratch": {
          "title": "Mulai dari nol",
          "body": "Belum ada stok. Bahan masuk lewat belanja bahan, lalu part dan barang jadi terbentuk dari batch cetak dan perakitan."
        },
        "existingStock": {
          "title": "Bawa stok yang sudah ada",
          "body": "Sudah punya filamen, part, atau barang jadi. Hitung stoknya pada tanggal mulai pakai dan catat sebagai saldo awal: bahan dengan biaya per satuan, part dan barang jadi jumlahnya saja."
        }
      },
      "costWarning": {
        "title": "Isi biaya stok bahan sebelum batch cetak pertama",
        "body": "Batch cetak mengambil gram dari stok bahan dengan biaya rata-rata stok itu. Stok bahan yang belum pernah diisi lewat belanja bahan atau saldo awal biayanya Rp 0, sehingga batch tercatat tanpa biaya bahan dan HPP terlihat terlalu rendah."
      },
      "items": {
        "adoption": {
          "title": "Tanggal mulai pakai",
          "body": "Hari Tridi mulai menjadi catatan resmi. Saldo awal memakai tanggal ini, dan tidak ada catatan yang boleh bertanggal sebelumnya.",
          "who": "Pemilik"
        },
        "pools": {
          "title": "Stok bahan dan biayanya",
          "body": "Buat stok bahan untuk tiap filamen dan komponen, lalu isi biayanya lewat belanja bahan atau saldo awal.",
          "who": "Pemilik membuat stok bahan dan saldo awal; belanja bahan: Pemilik dan Staf"
        },
        "machines": {
          "title": "Mesin",
          "body": "Daftarkan printer. Harga beli, umur pakai (jam), dan daya (watt) dipakai untuk tarif mesin di HPP.",
          "who": "Pemilik"
        },
        "catalog": {
          "title": "Produk, model, BOM, dan varian",
          "body": "Buat produk dan modelnya, unggah versi model dengan resep cetak, atur daftar bahan (BOM), lalu buat varian yang memetakan tiap slot warna ke stok bahan.",
          "who": "Pemilik"
        },
        "channels": {
          "title": "Kanal penjualan",
          "body": "Tempat yang menyimpan dan menjual barang: mitra titip jual atau penjualan langsung.",
          "who": "Pemilik"
        },
        "vendorPrices": {
          "title": "Harga vendor",
          "body": "Harga yang Anda terima per unit; menjadi isian awal di laporan penjualan.",
          "who": "Pemilik"
        },
        "cogsSettings": {
          "title": "Pengaturan HPP",
          "body": "Tarif tenaga kerja, harga listrik, biaya perawatan, margin target, dan yield default.",
          "who": "Pemilik"
        }
      }
    },
    "steps": {
      "title": "Langkah demi langkah",
      "intro": "Salah catat? Catatan yang sudah diposting tidak diubah: Pemilik menganulirnya, lalu mencatat ulang.",
      "pools": {
        "body": "Bahan masuk ke stok bahan lewat belanja bahan (sekaligus tercatat sebagai pengeluaran) atau saldo awal. Stok bahan menyimpan jumlah dan biaya rata-rata per satuan.",
        "who": "Belanja bahan: Pemilik dan Staf. Membuat stok bahan dan saldo awal: Pemilik"
      },
      "batch": {
        "body": "Satu mesin mencetak satu versi model sebanyak beberapa pelat. Saat selesai, catat part OK dan gagal, gram per slot warna, dan waktu cetak. Gram diambil dari stok bahan; part OK dari batch produksi masuk ke WIP.",
        "who": "Pemilik dan Staf"
      },
      "wip": {
        "body": "Part yang sudah dicetak tapi belum dirakit, dihitung per model dan warna. Terisi otomatis dari batch cetak dan tidak boleh minus.",
        "who": "Otomatis dari batch cetak; Pemilik dan Staf bisa melihat dan menyesuaikannya"
      },
      "assembly": {
        "body": "Merakit part WIP dan komponen menjadi barang jadi untuk satu varian sesuai daftar bahan (BOM), dengan menit kerja. Setiap produk wajib melalui perakitan.",
        "who": "Pemilik dan Staf"
      },
      "finishedGoods": {
        "body": "Unit siap jual per varian yang ada di gudang. Hanya bertambah dari perakitan (atau saldo awal) dan tidak boleh minus.",
        "who": "Otomatis dari perakitan; Pemilik dan Staf bisa melihat dan menyesuaikannya"
      },
      "dispatch": {
        "body": "Mengirim barang jadi dari gudang ke satu kanal penjualan, banyak varian sekaligus. Stok gudang berkurang, stok di kanal bertambah.",
        "who": "Pemilik dan Staf"
      },
      "channelStock": {
        "body": "Unit per varian yang ada di tiap kanal penjualan. Barang yang kembali ke gudang dicatat sebagai retur.",
        "who": "Pemilik dan Staf"
      },
      "salesReport": {
        "body": "Laporan berkala dari kanal: periode, unit terjual per varian, harga vendor, dan jumlah setoran. Unit terjual keluar dari stok di kanal, dan HPP saat itu disimpan di tiap baris.",
        "who": "Pemilik; Staf hanya melihat jumlah unit"
      },
      "payment": {
        "body": "Uang yang diterima untuk sebuah laporan penjualan, dicatat di laporannya; boleh dicicil sampai lunas. Sisa tagihan per kanal ada di layar Sisa tagihan.",
        "who": "Pemilik"
      },
      "expenses": {
        "body": "Semua uang keluar beserta kategorinya. Belanja bahan otomatis tercatat sebagai pengeluaran; ongkir dicatat terpisah.",
        "who": "Pemilik dan Staf; Staf hanya melihat pengeluarannya sendiri"
      },
      "cogs": {
        "body": "Biaya per unit tiap varian dari data nyata: gram × biaya stok bahan dan jam × tarif mesin dari 10 batch produksi terakhir (per part OK), ditambah komponen dan tenaga perakitan. Kemasan tidak termasuk.",
        "who": "Melihat: Pemilik dan Staf. Pengaturan HPP: Pemilik"
      }
    },
    "glossary": {
      "title": "Istilah",
      "terms": {
        "pool": {
          "term": "Stok bahan",
          "definition": "Stok satu bahan, filamen dalam gram atau komponen dalam pcs, dengan jumlah dan biaya rata-rata per satuan."
        },
        "restock": {
          "term": "Belanja bahan",
          "definition": "Pembelian bahan: satu pengeluaran berisi baris stok bahan, jumlah, dan harga yang menambah stok beserta biayanya."
        },
        "openingBalance": {
          "term": "Saldo awal",
          "definition": "Stok yang sudah ada pada tanggal mulai pakai, dicatat sebelum mutasi lain dan bukan pengeluaran."
        },
        "adoptionDate": {
          "term": "Tanggal mulai pakai",
          "definition": "Tanggal Tridi mulai menjadi catatan resmi; tidak ada catatan yang boleh bertanggal sebelumnya."
        },
        "product": {
          "term": "Produk",
          "definition": "Desain barang cetak yang dijual, dengan satu atau lebih model, satu daftar bahan (BOM), dan varian."
        },
        "model": {
          "term": "Model",
          "definition": "Satu part cetak dari sebuah produk, dengan versi file dan resep cetaknya."
        },
        "variant": {
          "term": "Varian",
          "definition": "Versi warna sebuah produk yang memetakan tiap slot warna ke stok bahan; satuan stok barang jadi dan HPP."
        },
        "bom": {
          "term": "Daftar bahan (BOM)",
          "definition": "Isi satu unit produk, yaitu model × jumlah dan komponen × jumlah, berlaku mulai tanggal tertentu."
        },
        "batch": {
          "term": "Batch cetak",
          "definition": "Satu mesin mencetak satu versi model sebanyak beberapa pelat, bernomor seperti B-0001."
        },
        "wip": {
          "term": "Part belum dirakit (WIP)",
          "definition": "Part yang sudah dicetak tapi belum dirakit, dihitung per model dan warna."
        },
        "assembly": {
          "term": "Perakitan",
          "definition": "Mengubah part WIP dan komponen menjadi barang jadi untuk satu varian."
        },
        "finishedGoods": {
          "term": "Barang jadi",
          "definition": "Unit siap jual per varian yang disimpan di gudang."
        },
        "channel": {
          "term": "Kanal penjualan",
          "definition": "Tempat yang menyimpan dan menjual barang, misalnya mitra titip jual atau penjualan langsung."
        },
        "dispatch": {
          "term": "Pengiriman",
          "definition": "Satu kiriman barang jadi dari gudang ke satu kanal penjualan."
        },
        "channelStock": {
          "term": "Stok di kanal",
          "definition": "Unit sebuah varian yang sedang ada di satu kanal penjualan."
        },
        "salesReport": {
          "term": "Laporan penjualan",
          "definition": "Laporan berkala dari kanal berisi unit terjual per varian, harga vendor, dan jumlah setoran."
        },
        "vendorPrice": {
          "term": "Harga vendor",
          "definition": "Harga yang Anda terima per unit dari kanal, berlaku mulai tanggal tertentu."
        },
        "payment": {
          "term": "Pembayaran",
          "definition": "Uang yang diterima untuk sebuah laporan penjualan; boleh dicicil sampai lunas."
        },
        "expense": {
          "term": "Pengeluaran",
          "definition": "Catatan uang keluar dengan kategori, termasuk belanja bahan dan ongkir."
        },
        "cogs": {
          "term": "HPP",
          "definition": "Harga pokok per unit sebuah varian dari data nyata: bahan, mesin, komponen, dan tenaga perakitan."
        },
        "adjustment": {
          "term": "Penyesuaian stok",
          "definition": "Koreksi jumlah stok setelah dihitung ulang, rusak, atau hilang, dengan alasannya."
        },
        "void": {
          "term": "Anulir",
          "definition": "Koreksi oleh Pemilik: catatan dibatalkan dengan mutasi balik yang persis sama, lalu dicatat ulang."
        }
      }
    },
    "mcp": {
      "title": "Hubungkan ke ChatGPT atau Claude (MCP)",
      "nav": "MCP",
      "intro": "MCP adalah cara standar menghubungkan aplikasi AI ke aplikasi lain. Setelah Tridi terhubung, Anda bisa bertanya soal katalog, stok bahan, dan HPP, atau menyiapkan produk baru, cukup lewat obrolan di ChatGPT atau Claude.",
      "staffNote": "Hanya Pemilik yang bisa menghubungkan aplikasi AI.",
      "serverUrl": "Alamat server MCP",
      "copy": "Salin",
      "copied": "Tersalin",
      "setupTitle": "Cara menghubungkan",
      "chatgpt": {
        "title": "ChatGPT",
        "requirement": "Perlu paket Plus, Pro, Business, Enterprise, atau Edu, di ChatGPT versi web (belum bisa di aplikasi HP).",
        "steps": [
          "Buka Settings → Security and login, lalu nyalakan Developer mode.",
          "Buka Plugins, tekan tombol +, lalu buat aplikasi MCP baru: beri nama \"Tridi\", tempel alamat server MCP di atas, dan pilih autentikasi OAuth.",
          "ChatGPT membuka halaman \"Hubungkan ChatGPT?\" dari Tridi. Masuk bila diminta, pilih workspace, lalu tekan Izinkan.",
          "Di obrolan baru, buka menu +, pilih Developer mode, lalu aktifkan aplikasi Tridi."
        ]
      },
      "claude": {
        "title": "Claude",
        "requirement": "Perlu paket Pro atau Max. Di paket Team atau Enterprise, Owner organisasi Claude yang menambahkannya lewat Organization settings → Connectors.",
        "steps": [
          "Buka Customize → Connectors, lalu tekan Add custom connector.",
          "Beri nama \"Tridi\", tempel alamat server MCP di atas, lalu tekan Add. Kolom OAuth di Advanced settings dibiarkan kosong.",
          "Tekan Connect. Claude membuka halaman \"Hubungkan Claude?\" dari Tridi. Masuk bila diminta, pilih workspace, lalu tekan Izinkan.",
          "Di obrolan, nyalakan Tridi dari menu alat (tombol + atau ikon alat) bila belum aktif."
        ]
      },
      "canDo": {
        "title": "Yang bisa dilakukan AI",
        "items": [
          "Mencari stok bahan, produk, dan detail produk (model, resep cetak, varian, BOM, HPP).",
          "Membuat produk baru beserta model, slot warna, resep cetak versi pertama, varian, dan BOM. AI selalu menampilkan pratinjau dulu dan baru menyimpan setelah Anda setuju.",
          "Tidak bisa void, mengubah stok, mencatat penjualan atau pembayaran, atau mengubah pengaturan. File cetak (.3mf/.stl) tetap diunggah di Tridi."
        ]
      },
      "examples": {
        "title": "Contoh pemakaian",
        "intro": "Mulai perintah dengan \"Pakai Tridi\" supaya AI memakai data Tridi, bukan menebak. Semua angka di Tridi bilangan bulat: rupiah, gram, menit, dan basis poin (bps).",
        "prompt": "Anda tulis",
        "result": "Yang terjadi",
        "items": {
          "lowStock": {
            "title": "Cek stok bahan yang menipis",
            "prompt": "Pakai Tridi: filamen apa saja yang stoknya di bawah minimum? Urutkan dari yang paling sedikit.",
            "result": "AI mencari stok bahan di Tridi, lalu menampilkan daftar filamen dengan sisa gram, batas minimum, dan nilai stoknya."
          },
          "cogs": {
            "title": "Lihat HPP dan resep sebuah produk",
            "prompt": "Pakai Tridi: tampilkan detail produk DRG. Berapa HPP per unit tiap varian, dan berapa gram filamen per plate di resepnya?",
            "result": "AI membuka produk itu dan merangkum model, resep cetak, varian, BOM, serta HPP per unit tiap varian."
          },
          "compare": {
            "title": "Bandingkan produk",
            "prompt": "Pakai Tridi: dari semua produk aktif, varian mana yang HPP per unitnya paling tinggi? Buat tabel kode, varian, dan HPP.",
            "result": "AI membaca daftar produk lalu detail tiap produk, dan menyusun tabel perbandingan. Untuk katalog besar, sebut beberapa kode produk saja supaya lebih cepat."
          },
          "create": {
            "title": "Buat produk baru dari obrolan",
            "prompt": "Pakai Tridi: buat produk baru \"Kucing Duduk\" kode KCG. Satu model \"Badan\" dengan slot warna Body dan Mata; 4 part per plate, 120 menit per plate, Body 40 g dan Mata 2 g per plate. Varian \"Hitam\": Body dan Mata pakai PLA Basic Black. BOM: 1 Badan. Tampilkan pratinjaunya dulu.",
            "result": "AI mencari stok bahan PLA Basic Black, lalu menampilkan pratinjau: produk, model, slot, resep, varian, dan BOM. Belum ada yang tersimpan. Setelah Anda balas \"Ya, simpan\", produk dibuat dengan status Dalam pengembangan dan AI memberi tautannya."
          },
          "slicer": {
            "title": "Salin ringkasan dari slicer",
            "prompt": "Pakai Tridi: ini ringkasan plate dari Bambu Studio untuk model \"Kepala\" (slot Kepala dan Telinga): [tempel ringkasan]. Buat produk baru kode KPL dari data ini, bulatkan gram dan menit, lalu tampilkan pratinjaunya.",
            "result": "AI mengambil jumlah part, waktu cetak, dan gram per warna dari teks itu, membulatkannya, lalu menampilkan pratinjau untuk Anda periksa sebelum disimpan."
          }
        }
      },
      "afterCreate": {
        "title": "Setelah produk dibuat lewat AI",
        "items": [
          "Buka produknya di Tridi dan unggah file cetak (.3mf/.stl) ke versi model. Versi tanpa file belum bisa dipakai untuk batch cetak.",
          "Periksa varian dan BOM, lalu ubah status produk ke Aktif bila sudah siap dijual.",
          "Perubahan pada produk yang sudah ada (ganti nama, tambah varian, versi model baru) masih dilakukan di Tridi."
        ]
      },
      "troubleshooting": {
        "title": "Kalau ada masalah",
        "items": [
          "Halaman \"Hanya Owner\" muncul: akun yang dipakai bukan Pemilik di workspace mana pun. Masuk dengan akun Pemilik.",
          "AI berkata Tridi tidak terhubung atau ditolak: koneksi mungkin sudah diputus atau peran Anda berubah. Hubungkan ulang dari aplikasi AI.",
          "AI menebak tanpa data: tulis \"Pakai Tridi\" di awal perintah, dan pastikan Tridi aktif di menu alat obrolan itu.",
          "ChatGPT di HP: aplikasi MCP baru bisa dipakai di ChatGPT versi web."
        ]
      },
      "manage": "Untuk melihat atau memutuskan aplikasi yang terhubung, buka halaman Akun → Aplikasi AI terhubung.",
      "manageLink": "Buka halaman Akun"
    },
    "overviewNav": "Cara kerja"
  },
  "notFound": {
    "title": "Halaman tidak ditemukan",
    "body": "Halaman ini tidak ada, atau Anda tidak punya akses ke sana.",
    "backToLogin": "Kembali ke halaman masuk"
  },
  "noWorkspace": {
    "title": "Belum ada workspace",
    "body": "Akun Anda belum punya akses ke workspace mana pun. Minta undangan ke pemilik workspace."
  },
  "batches": {
    "title": "Batch cetak",
    "start": "Mulai batch cetak",
    "back": "Kembali ke batch cetak",
    "empty": "Belum ada batch cetak.",
    "emptyFiltered": "Tidak ada batch cetak yang cocok dengan filter.",
    "duration": "{{hours}} jam {{minutes}} menit",
    "versionLabel": "{{model}} v{{version}} · {{code}} {{product}}",
    "status": {
      "printing": "Sedang mencetak",
      "completed": "Selesai",
      "cancelled": "Dibatalkan"
    },
    "purpose": {
      "production": "Produksi",
      "prototype": "Prototipe",
      "calibration": "Kalibrasi",
      "personal": "Pribadi"
    },
    "yieldPercent": "{{percent}}%",
    "columns": {
      "number": "Nomor batch",
      "machine": "Mesin",
      "modelVersion": "Versi model",
      "variant": "Varian (isian awal)",
      "purpose": "Tujuan cetak",
      "status": "Status",
      "plates": "Pelat",
      "date": "Tanggal",
      "createdBy": "Dicatat oleh",
      "partsOk": "Part OK",
      "partsFailed": "Part gagal",
      "cancelReason": "Alasan batal",
      "cancelledAt": "Dibatalkan pada",
      "yield": "Tingkat berhasil",
      "product": "Produk",
      "model": "Model"
    },
    "detail": {
      "title": "Detail batch cetak",
      "complete": "Selesaikan",
      "cancel": "Batalkan",
      "partsPerPlate": "Part per pelat",
      "estMinutes": "Perkiraan waktu",
      "snapshotHint": "Perkiraan disalin dari resep saat batch cetak dimulai dan tidak berubah walau resep diubah.",
      "slots": "Slot warna",
      "pool": "Stok bahan",
      "estGrams": "Perkiraan gram",
      "actualGrams": "Gram aktual",
      "results": "Hasil",
      "partsOk": "Part OK",
      "partsFailed": "Part gagal",
      "partsPrinted": "Part dicetak",
      "failureReason": "Alasan gagal",
      "actualMinutes": "Waktu aktual",
      "completedAt": "Diselesaikan pada",
      "recordedAt": "Dicatat pada",
      "wip": "Part belum dirakit (WIP)",
      "wipQtyAdded": "Part ditambahkan",
      "movements": "Mutasi stok",
      "movementWip": "Part belum dirakit (WIP)",
      "qtyDelta": "Jumlah",
      "valueDelta": "Nilai",
      "cancelReason": "Alasan batal",
      "wastedGrams": "Gram terbuang",
      "cancelledAt": "Dibatalkan pada",
      "editFailureReason": "Ubah alasan gagal"
    },
    "form": {
      "title": "Mulai batch cetak",
      "machine": "Mesin",
      "noIdleMachine": "Tidak ada mesin yang siap. Selesaikan atau batalkan batch cetak yang berjalan dulu.",
      "product": "Produk",
      "model": "Model",
      "currentVersion": "Versi yang dicetak: v{{version}} (versi terbaru)",
      "noCurrentVersion": "Model ini belum punya versi yang aktif.",
      "variant": "Varian (isian awal, opsional)",
      "noVariant": "Tanpa varian",
      "variantHint": "Mengisi stok bahan tiap slot dari warna varian. Pilihan tetap bisa diubah.",
      "purpose": "Tujuan cetak",
      "plates": "Pelat",
      "platesInvalid": "Isi angka bulat lebih dari 0.",
      "slots": "Stok bahan per slot warna",
      "selectPool": "Pilih filamen",
      "estGrams": "Perkiraan",
      "estTime": "Perkiraan waktu",
      "date": "Tanggal",
      "dateHint": "Tanggal ini dipakai juga saat batch cetak diselesaikan atau dibatalkan.",
      "select": "Pilih",
      "required": "Wajib diisi.",
      "save": "Mulai cetak",
      "saving": "Menyimpan…",
      "cancel": "Batal",
      "versionNoFiles": "v{{version}} belum punya file .3mf / .stl, jadi belum bisa dipakai untuk batch cetak. Tambahkan file di detail versinya."
    },
    "errors": {
      "machineBusy": "Mesin ini sudah mencetak batch lain. Pilih mesin lain atau selesaikan batch cetak itu dulu.",
      "variantNeedsColor": "Varian ini Perlu warna pada slot yang dipakai versi ini. Atur warnanya di varian, atau kosongkan isian awal.",
      "recipeSlotArchived": "Resep versi ini memakai slot warna yang diarsipkan. Kembalikan slot itu dari arsip atau ubah resepnya.",
      "validationFailed": "Periksa lagi isian Anda.",
      "validationFailedFields": "Periksa lagi isian berikut: {{fields}}.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "invalidTransition": "Batch cetak ini sudah tidak sedang mencetak. Muat ulang halaman."
    },
    "failureReason": {
      "adhesion": "Adhesion",
      "spaghetti": "Spaghetti",
      "layer_shift": "Layer shift",
      "clog": "Clog / under-extrusion",
      "warping": "Warping",
      "quality": "Stringing / kualitas",
      "other": "Listrik / lainnya"
    },
    "cancelReason": {
      "wrong_file_or_color": "Salah file / warna",
      "machine_needed": "Mesin dibutuhkan",
      "power_outage": "Listrik padam",
      "other": "Lainnya"
    },
    "cancel": {
      "title": "Batalkan batch cetak {{number}}",
      "description": "Untuk batch cetak yang dihentikan dengan sengaja. Cacat cetak dicatat lewat Selesaikan (part OK boleh 0).",
      "reason": "Alasan batal",
      "selectReason": "Pilih alasan",
      "grams": "Gram terbuang per slot warna (opsional)",
      "gramsHint": "Dikurangi dari stok bahan. Kosong atau 0 berarti tidak ada yang dikurangi; slot yang memakai stok bahan yang sama dikelompokkan.",
      "estimate": "Perkiraan: {{grams}}",
      "wholeNumber": "Isi angka bulat 0 atau lebih, atau kosongkan.",
      "noWipHint": "Tidak ada part yang masuk WIP. Batch cetak yang dibatalkan tidak dihitung dalam HPP dan tingkat berhasil.",
      "save": "Batalkan batch cetak",
      "saving": "Menyimpan…",
      "back": "Kembali"
    },
    "complete": {
      "title": "Selesaikan batch cetak",
      "partsOk": "Part OK",
      "partsFailed": "Part gagal",
      "partsFailedHint": "Diisi otomatis: perkiraan {{expected}} part dikurangi part OK.",
      "failureReason": "Alasan gagal",
      "selectReason": "Pilih alasan",
      "grams": "Gram aktual per slot warna",
      "gramsHint": "Diisi dengan perkiraan. Ubah sesuai pemakaian sebenarnya; slot yang memakai stok bahan yang sama dikelompokkan.",
      "estimate": "Perkiraan: {{grams}}",
      "actualMinutes": "Waktu aktual (menit)",
      "actualMinutesHint": "Diisi dengan waktu sejak batch cetak dimulai.",
      "wholeNumber": "Isi angka bulat 0 atau lebih.",
      "positiveNumber": "Isi angka bulat lebih dari 0.",
      "nothingPrinted": "Jumlah part OK dan part gagal harus lebih dari 0.",
      "wipHint": "Part OK masuk ke Part belum dirakit (WIP).",
      "noWipHint": "Tujuan cetak bukan produksi: hanya filamen yang dikurangi, tidak ada part yang masuk WIP.",
      "save": "Selesaikan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "entryMode": {
      "after_the_fact": "Dicatat setelah selesai"
    },
    "record": {
      "title": "Catat batch selesai",
      "description": "Untuk batch cetak yang sudah selesai tetapi belum dicatat: isi data mulai dan hasilnya sekaligus. Stok bahan dan WIP langsung diperbarui.",
      "machineHint": "Mesin yang sedang mencetak boleh dipilih.",
      "version": "Versi model",
      "versionOption": "v{{version}}",
      "currentVersionOption": "v{{version}} (versi terbaru)",
      "noVersion": "Model ini belum punya versi aktif dengan file .3mf / .stl.",
      "results": "Hasil",
      "actualGrams": "Gram aktual",
      "actualMinutesHint": "Lama cetak sebenarnya, dalam menit.",
      "dateHint": "Tanggal batch cetak selesai. Tidak boleh sebelum tanggal mulai pakai atau di masa depan.",
      "save": "Catat batch selesai"
    },
    "list": {
      "parts": "{{ok}} OK, {{failed}} gagal",
      "plates": "{{count}} pelat",
      "yield": "{{percent}}% berhasil",
      "cancelled": "Dibatalkan: {{reason}}"
    }
  },
  "assemblies": {
    "title": "Perakitan",
    "record": "Catat perakitan",
    "back": "Kembali ke perakitan",
    "empty": "Belum ada perakitan.",
    "columns": {
      "date": "Tanggal",
      "variant": "Varian",
      "qty": "Jumlah",
      "laborMinutes": "Waktu kerja",
      "createdBy": "Dicatat oleh"
    },
    "minutes": "{{count}} menit",
    "detail": {
      "title": "Detail perakitan",
      "bom": "Versi BOM",
      "bomValue": "Berlaku mulai {{date}}",
      "lines": "Yang dipakai",
      "expected": "Seharusnya",
      "actual": "Aktual",
      "substitute": "Pengganti",
      "movements": "Mutasi stok",
      "movementWip": "Part belum dirakit (WIP)",
      "movementFinishedGoods": "Barang jadi",
      "total": "Total aktual",
      "qtyDelta": "Jumlah",
      "valueDelta": "Nilai"
    },
    "form": {
      "title": "Catat perakitan",
      "product": "Produk",
      "variant": "Varian",
      "select": "Pilih",
      "qty": "Jumlah dirakit",
      "qtyInvalid": "Isi angka bulat lebih dari 0.",
      "buildable": "Bisa dirakit pada tanggal ini: {{count}}",
      "withSubstitutes": "+{{count}} dengan pengganti",
      "buildableHint": "Hanya perkiraan dari stok saat ini; jumlah dirakit boleh lebih.",
      "date": "Tanggal",
      "dateHint": "BOM yang berlaku pada tanggal ini yang dipakai.",
      "lines": "Yang dipakai per baris BOM",
      "linesHint": "Diisi dari BOM × jumlah dirakit, mulai dari stok part terbanyak. Ubah jumlah aktual kalau ada part yang rusak.",
      "expected": "Seharusnya: {{qty}}",
      "available": "Tersedia: {{qty}}",
      "actual": "Jumlah aktual",
      "substituteBadge": "Pengganti",
      "addSubstitute": "Pakai pengganti",
      "selectSubstitute": "Pilih part pengganti",
      "substituteWarning": "Warna part ini berbeda dari varian pada slot: {{slots}}. Tetap pakai sebagai pengganti?",
      "confirmSubstitute": "Ya, pakai pengganti",
      "cancelSubstitute": "Batal",
      "noItems": "Tidak ada Part belum dirakit (WIP) untuk model ini.",
      "wipShort": "Part belum dirakit (WIP) tidak cukup: tersedia {{qty}}.",
      "toAdjustment": "Buat penyesuaian WIP",
      "componentNegative": "Stok komponen akan minus dan ditandai Perlu hitung stok.",
      "wholeNumber": "Isi angka bulat 0 atau lebih.",
      "laborMinutes": "Waktu kerja (menit)",
      "laborMinutesHint": "Waktu kerja untuk sesi perakitan ini.",
      "note": "Catatan (opsional)",
      "required": "Wajib diisi.",
      "save": "Simpan perakitan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "buildableReason": {
      "no_bom": "Belum ada BOM yang berlaku pada tanggal ini.",
      "variant_archived": "Varian ini diarsipkan.",
      "product_archived": "Produk ini diarsipkan."
    },
    "errors": {
      "wouldGoNegative": "Part belum dirakit (WIP) tidak cukup: stok tidak boleh kurang dari 0. Perbaiki jumlahnya, atau catat penyesuaian WIP dulu.",
      "wipPartPreVn": "Part ini dicetak sebelum versi tidak kompatibel (pre-vN) dan tidak bisa dirakit. Pilih part lain.",
      "noBomInEffect": "Belum ada BOM yang berlaku pada tanggal ini.",
      "poolArchived": "Komponen di BOM ini sudah diarsipkan. Kembalikan stok bahannya dari arsip dulu, atau isi jumlah aktualnya 0.",
      "variantNeedsColor": "Varian ini Perlu warna pada slot model di BOM yang berlaku. Atur warnanya di varian dulu.",
      "validationFailed": "Periksa lagi isian Anda.",
      "validationFailedFields": "Periksa lagi isian berikut: {{fields}}.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "list": {
      "units_other": "{{count}} pcs"
    }
  },
  "machines": {
    "title": "Mesin",
    "newMachine": "Mesin baru",
    "archived": "Diarsipkan",
    "empty": "Belum ada mesin di daftar ini.",
    "edit": "Ubah mesin",
    "back": "Kembali ke mesin",
    "hourlyRateValue": "Tarif mesin (Rp/jam): {{value}}",
    "status": {
      "idle": "Siap",
      "printing": "Sedang mencetak",
      "printingBatch": "Sedang mencetak {{batchNo}}"
    },
    "detail": {
      "title": "Detail mesin",
      "currentBatch": "Batch cetak berjalan",
      "batchHistory": "Riwayat batch cetak",
      "model": "Model mesin",
      "purchasePrice": "Harga beli (Rp)",
      "lifetimeHours": "Umur pakai (jam)",
      "watts": "Daya (watt)",
      "hourlyRate": "Tarif mesin (Rp/jam)",
      "rateHint": "Tarif mesin = (harga beli ÷ umur pakai + daya ÷ 1.000 × harga listrik / kWh) × (1 + biaya perawatan). Ditampilkan dibulatkan ke rupiah; HPP memakai angka persisnya."
    },
    "form": {
      "newTitle": "Mesin baru",
      "editTitle": "Ubah mesin",
      "name": "Nama",
      "nameHint": "Paling banyak 100 karakter, tidak boleh sama dengan mesin lain, termasuk yang diarsipkan.",
      "model": "Model printer (opsional)",
      "rateInputs": "Data tarif mesin",
      "rateInputsHint": "Dipakai untuk menghitung tarif mesin (HPP). Selama salah satu kosong, tarif mesin tampil “—”.",
      "purchasePrice": "Harga beli (Rp)",
      "lifetimeHours": "Umur pakai (jam)",
      "watts": "Daya (watt)",
      "required": "Wajib diisi.",
      "purchasePriceInvalid": "Isi angka bulat 0 sampai 1.000.000.000.000.",
      "positiveInvalid": "Isi angka bulat lebih dari 0.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal",
      "brand": "Merek printer (opsional)"
    },
    "archive": {
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmBody": "Mesin ini disembunyikan dari daftar dan tidak bisa dipilih untuk batch cetak baru. Riwayatnya tetap tersimpan.",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Mesin ini muncul lagi di daftar dan bisa dipilih untuk batch cetak baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip.",
      "blockedWhilePrinting": "Mesin ini sedang mencetak {{batchNo}}. Selesaikan atau batalkan batch cetak itu dulu sebelum mengarsipkan mesin."
    },
    "errors": {
      "nameTaken": "Nama ini sudah dipakai mesin lain di workspace ini, termasuk mesin yang diarsipkan.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "conflict": "Mesin ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi.",
      "machinePrinting": "Mesin ini sedang mencetak. Selesaikan atau batalkan batch cetaknya dulu, lalu coba lagi."
    },
    "rateBreakdown": {
      "title": "Rincian tarif mesin",
      "depreciation": "Penyusutan per jam (Rp)",
      "power": "Listrik per jam (Rp)",
      "maintenance": "Biaya perawatan per jam (Rp)",
      "total": "Tarif mesin per jam (Rp)"
    },
    "rateMissing": "Lengkapi data tarif: {{fields}}",
    "rateMissingFields": {
      "purchase_price": "harga beli",
      "lifetime_hours": "umur pakai",
      "watts": "daya",
      "electricity_price_per_kwh": "harga listrik / kWh di Pengaturan HPP"
    },
    "list": {
      "rate": "Rp {{value}}/jam"
    }
  },
  "salesChannels": {
    "title": "Kanal penjualan",
    "newChannel": "Kanal penjualan baru",
    "archived": "Diarsipkan",
    "empty": "Belum ada kanal penjualan di daftar ini.",
    "edit": "Ubah kanal penjualan",
    "back": "Kembali ke kanal penjualan",
    "unitsAtChannel": "Stok di kanal: {{count}} pcs",
    "kinds": {
      "consignment": "Konsinyasi",
      "direct": "Langsung"
    },
    "detail": {
      "title": "Detail kanal penjualan",
      "kind": "Jenis",
      "contactName": "Nama kontak",
      "contactPhone": "Nomor telepon",
      "address": "Alamat",
      "settlementCycle": "Catatan jadwal laporan",
      "settlementCycleDays": "Batas hari laporan",
      "notes": "Catatan",
      "stock": "Stok di kanal",
      "noStock": "Belum ada stok di kanal ini.",
      "dispatches": "Pengiriman",
      "returns": "Retur",
      "noDispatches": "Belum ada pengiriman untuk kanal ini.",
      "noReturns": "Belum ada retur dari kanal ini.",
      "salesReports": "Laporan penjualan",
      "noSalesReports": "Belum ada laporan penjualan untuk kanal ini."
    },
    "form": {
      "newTitle": "Kanal penjualan baru",
      "editTitle": "Ubah kanal penjualan",
      "name": "Nama",
      "nameHint": "Paling banyak 100 karakter, tidak boleh sama dengan kanal penjualan lain, termasuk yang diarsipkan.",
      "kind": "Jenis",
      "kindLockedHint": "Jenis tidak bisa diubah lagi: kanal ini sudah dipakai (ada stok yang pernah masuk atau laporan penjualan). Arsipkan kanal ini dan buat yang baru jika jenisnya salah.",
      "contactName": "Nama kontak (opsional)",
      "contactPhone": "Nomor telepon (opsional)",
      "address": "Alamat (opsional)",
      "settlementCycle": "Catatan jadwal laporan (opsional)",
      "settlementCycleHint": "Keterangan bebas, misalnya \"tiap akhir bulan\" atau \"setiap Senin\". Hanya catatan, tidak dihitung.",
      "settlementCycleDays": "Batas hari laporan (opsional)",
      "settlementCycleDaysHint": "Angka hari. Kanal ditandai terlambat di dasbor jika belum mengirim laporan penjualan selama jumlah hari ini.",
      "notes": "Catatan (opsional)",
      "required": "Wajib diisi.",
      "daysInvalid": "Isi angka bulat lebih dari 0.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "archive": {
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmBody": "Kanal ini disembunyikan dari daftar dan tidak bisa dipilih untuk pengiriman baru. Retur masih bisa dicatat sampai stok di kanal ini habis. Riwayatnya tetap tersimpan.",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Kanal ini muncul lagi di daftar dan bisa dipilih untuk pengiriman baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip."
    },
    "errors": {
      "nameTaken": "Nama ini sudah dipakai kanal penjualan lain di workspace ini, termasuk yang diarsipkan.",
      "kindInUse": "Jenis kanal penjualan tidak bisa diubah lagi: kanal ini sudah dipakai. Perubahan lain di form ini juga tidak tersimpan. Muat ulang halaman, lalu ubah selain jenisnya.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "list": {
      "units": "{{count}} pcs"
    }
  },
  "salesReports": {
    "title": "Laporan penjualan",
    "new": "Laporan penjualan baru",
    "back": "Kembali ke laporan penjualan",
    "empty": "Belum ada laporan penjualan.",
    "emptyFiltered": "Tidak ada laporan penjualan yang cocok dengan filter.",
    "units_other": "{{count}} pcs",
    "period": "{{from}} – {{to}}",
    "priceChanged": "Harga diubah",
    "editSettlement": "Ubah jumlah setoran",
    "unreportedDays_other": "{{count}} hari belum dilaporkan",
    "statuses": {
      "unpaid": "Belum dibayar",
      "partially_paid": "Dibayar sebagian",
      "paid": "Lunas",
      "voided": "Dianulir"
    },
    "columns": {
      "channel": "Kanal penjualan",
      "period": "Periode",
      "date": "Tanggal",
      "units": "Terjual",
      "expected": "Perkiraan setoran",
      "settlement": "Jumlah setoran",
      "difference": "Selisih",
      "paid": "Sudah dibayar",
      "outstanding": "Sisa tagihan",
      "status": "Status",
      "createdBy": "Dicatat oleh"
    },
    "form": {
      "title": "Laporan penjualan baru",
      "channel": "Kanal penjualan",
      "periodStart": "Periode mulai",
      "periodEnd": "Periode sampai",
      "periodEndHint": "Tanggal laporan mengikuti akhir periode. Hari ini atau sebelumnya.",
      "periodInvalid": "Akhir periode tidak boleh sebelum awal periode.",
      "periodClamped": "Awal periode sebelum tanggal mulai pakai. Yang dihitung mulai {{date}}.",
      "backdateReason": "Alasan mundur tanggal",
      "backdateReasonHint": "Alasan ini disimpan di riwayat catatan.",
      "variant": "Varian",
      "selectVariant": "Pilih varian",
      "units": "Terjual (pcs)",
      "unitsInvalid": "Isi angka bulat 1 atau lebih.",
      "amountInvalid": "Isi angka bulat 0 atau lebih.",
      "channelStock": "Stok di kanal: {{qty}} pcs",
      "vendorPrice": "Harga vendor (Rp)",
      "prefilledPrice": "Harga berlaku: Rp {{price}}",
      "priceChanged": "Harga diubah",
      "settlement": "Jumlah setoran (Rp)",
      "settlementHint": "Kosongkan untuk memakai perkiraan setoran.",
      "differenceNote": "Catatan selisih",
      "differenceNoteHint": "Wajib diisi kalau setoran berbeda dari perkiraan.",
      "note": "Catatan (opsional)",
      "addLine": "Tambah baris",
      "removeLine": "Hapus baris",
      "zeroUnits": "Tanpa baris berarti laporan nol penjualan.",
      "toAdjustment": "Sesuaikan stok di kanal",
      "noChannels": "Belum ada kanal penjualan.",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail laporan penjualan",
      "lines": "Isi laporan",
      "noLines": "Laporan nol penjualan.",
      "movements": "Mutasi stok",
      "noMovements": "Tidak ada mutasi stok.",
      "differenceNote": "Catatan selisih: {{note}}",
      "periodClamped": "Periode yang dihitung mulai {{date}} (tanggal mulai pakai).",
      "cogsAtReport": "HPP saat laporan: Rp {{amount}}/pcs",
      "noCogs": "HPP saat laporan: —",
      "margin": "Margin: Rp {{amount}}",
      "marginPerUnit": "Margin per pcs: Rp {{amount}}",
      "marginTotal": "Total margin",
      "linesWithoutCogs_other": "{{count}} baris tanpa HPP tidak dihitung.",
      "cogsToday": "Lihat HPP hari ini",
      "priceChangedFrom": "Harga diubah dari Rp {{amount}}"
    },
    "errors": {
      "adoptionDateNotSet": "Tanggal mulai pakai belum diisi. Isi dulu di pengaturan.",
      "beforeAdoptionDate": "Akhir periode tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Akhir periode tidak boleh di masa depan.",
      "backdateLimitExceeded": "Akhir periode lebih dari {{days}} hari ke belakang.",
      "backdateReasonRequired": "Akhir periode lebih dari {{days}} hari ke belakang. Isi alasannya.",
      "periodOverlap": "Periode ini bertabrakan dengan laporan {{number}}.",
      "wouldGoNegative": "Stok di kanal tidak cukup: {{items}}. Sesuaikan stok kanal dulu.",
      "blockingItem": "{{label}} (sisa {{qty}} pcs)",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "list": {
      "settlement": "Setoran Rp {{amount}}",
      "paid": "Dibayar Rp {{amount}}",
      "outstanding": "Sisa Rp {{amount}}"
    }
  },
  "payments": {
    "title": "Pembayaran",
    "empty": "Belum ada pembayaran.",
    "record": "Catat pembayaran",
    "paid": "Sudah dibayar",
    "outstanding": "Sisa tagihan",
    "paidInFull": "Lunas saat simpan",
    "paidInFullHint": "Mencatat satu pembayaran sebesar jumlah setoran pada tanggal laporan.",
    "settlementLocked": "Jumlah setoran tidak bisa diubah lagi karena sudah ada pembayaran.",
    "form": {
      "title": "Catat pembayaran",
      "description": "Pembayaran hanya mencatat uang, tidak mengubah stok.",
      "date": "Tanggal bayar",
      "dateHint": "Hari ini atau sebelumnya.",
      "amount": "Jumlah (Rp)",
      "amountHint": "Paling banyak sisa tagihan Rp {{amount}}.",
      "amountInvalid": "Isi angka bulat 1 atau lebih.",
      "aboveOutstanding": "Lebih besar dari sisa tagihan (Rp {{amount}}).",
      "note": "Catatan (opsional)",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "outstandingScreen": {
      "title": "Sisa tagihan",
      "subtitle": "Sisa tagihan per kanal penjualan dari laporan yang belum lunas.",
      "total": "Total sisa tagihan",
      "empty": "Tidak ada sisa tagihan.",
      "archived": "Diarsipkan",
      "list": {
        "reports": "{{count}} laporan"
      }
    },
    "errors": {
      "exceedsSettlement": "Melebihi sisa tagihan (Rp {{amount}}).",
      "settlementLocked": "Jumlah setoran terkunci karena sudah ada pembayaran. Anulir pembayarannya dulu.",
      "reportHasPayments": "Anulir pembayaran {{numbers}} dulu sebelum menganulir laporan ini.",
      "reportVoided": "Laporan ini sudah dianulir, pembayaran tidak bisa dicatat.",
      "beforeAdoptionDate": "Tanggal bayar tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal bayar tidak boleh di masa depan.",
      "backdateLimitExceeded": "Tanggal bayar lebih dari {{days}} hari ke belakang.",
      "backdateReasonRequired": "Tanggal bayar lebih dari {{days}} hari ke belakang. Isi alasannya.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    }
  },
  "expenses": {
    "title": "Pengeluaran",
    "new": "Pengeluaran baru",
    "back": "Kembali ke pengeluaran",
    "empty": "Belum ada pengeluaran.",
    "filterMonth": "Bulan",
    "filterCategory": "Kategori pengeluaran",
    "categories": {
      "seeded": {
        "materialRestock": "Belanja bahan",
        "shipping": "Ongkos kirim",
        "packaging": "Kemasan",
        "consumables": "Bahan habis pakai",
        "machine": "Mesin",
        "utilities": "Listrik & utilitas",
        "other": "Lainnya"
      }
    },
    "deleted": "Dihapus",
    "openRestock": "Lihat belanja bahan",
    "total": "Total bulan ini",
    "columns": {
      "amount": "Jumlah",
      "vendor": "Penjual",
      "note": "Catatan",
      "createdBy": "Dicatat oleh"
    },
    "edit": "Ubah",
    "delete": "Hapus",
    "deleteTitle": "Hapus pengeluaran ini?",
    "deleteDescription": "Pengeluaran ini keluar dari daftar dan dari semua total. Catatannya tetap tersimpan di riwayat.",
    "deleteReason": "Alasan hapus",
    "deleteReasonHint": "Wajib diisi dan disimpan di riwayat catatan.",
    "deleteReasonRequired": "Wajib diisi.",
    "deleteConfirm": "Hapus",
    "form": {
      "title": "Pengeluaran baru",
      "editTitle": "Ubah pengeluaran",
      "description": "Pengeluaran hanya mencatat uang, tidak mengubah stok.",
      "date": "Tanggal",
      "dateHint": "Hari ini atau sebelumnya.",
      "backdateReason": "Alasan catat mundur",
      "backdateReasonHint": "Wajib diisi dan disimpan di riwayat catatan.",
      "category": "Kategori pengeluaran",
      "selectCategory": "Pilih kategori",
      "noCategories": "Belum ada kategori pengeluaran yang bisa dipilih. Belanja bahan hanya untuk belanja bahan.",
      "amount": "Jumlah (Rp)",
      "amountInvalid": "Isi angka bulat lebih dari 0.",
      "vendor": "Penjual / toko (opsional)",
      "note": "Catatan (opsional)",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "errors": {
      "adoptionDateNotSet": "Tanggal mulai pakai belum diisi. Pemilik harus mengisinya dulu di Pengaturan.",
      "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal tidak boleh di masa depan.",
      "backdateLimitExceeded": "Tanggal tidak boleh lebih dari {{days}} hari ke belakang.",
      "backdateReasonRequired": "Lebih dari {{days}} hari ke belakang. Isi alasannya untuk melanjutkan.",
      "restockReadonly": "Pengeluaran dari belanja bahan tidak bisa diubah atau dihapus. Anulir belanja bahannya.",
      "alreadyDeleted": "Pengeluaran ini sudah dihapus.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "filterDeleted": "Yang dihapus",
    "deletedShown": "Ditampilkan"
  },
  "reports": {
    "monthly": {
      "title": "Ringkasan bulanan",
      "subtitle": "Uang masuk dan keluar dalam satu bulan. Semua angka dihitung ulang saat dibuka, tidak ada yang disimpan.",
      "month": "Bulan",
      "paymentsReceived": "Pembayaran diterima",
      "expenses": "Pengeluaran per kategori",
      "expensesEmpty": "Belum ada pengeluaran bulan ini.",
      "expensesTotal": "Total pengeluaran",
      "netCash": "Kas bersih",
      "netCashHint": "Pembayaran diterima dikurangi total pengeluaran.",
      "materialWaste": "Material terbuang",
      "materialWasteHint": "Nilai bahan yang terbuang dari batch cetak yang dibatalkan. Tidak ikut dihitung di kas bersih (bahannya sudah dibayar saat belanja bahan) dan tidak masuk HPP.",
      "grossMargin": "Margin kotor",
      "grossMarginHint": "Unit terjual × (harga vendor − HPP), dihitung di bulan akhir periode laporan penjualan.",
      "grossMarginWithoutCogs": "{{count}} baris laporan penjualan belum punya HPP, jadi belum ikut dihitung."
    }
  },
  "vendorPrices": {
    "title": "Harga vendor",
    "subtitle": "Harga yang diterima usaha per unit. Harga default berlaku untuk semua kanal; harga khusus kanal mengalahkannya sejak tanggal berlakunya.",
    "searchLabel": "Cari varian",
    "searchPlaceholder": "Cari SKU atau nama varian",
    "empty": "Belum ada varian di daftar ini.",
    "defaultPrice": "Harga default",
    "overrides": "Harga khusus kanal",
    "noPrice": "Belum ada harga",
    "noOverrides": "Belum ada harga khusus kanal.",
    "cogs": "HPP / unit",
    "suggestedPrice": "Saran harga vendor",
    "effectiveFrom": "Berlaku mulai",
    "setPrice": "Atur harga",
    "history": "Riwayat harga",
    "noHistory": "Belum ada harga untuk varian ini.",
    "defaultLabel": "Semua kanal",
    "archived": "Diarsipkan",
    "atChannel": "Harga khusus kanal ini",
    "noneAtChannel": "Belum ada harga khusus untuk kanal ini.",
    "nextPage": "Halaman berikutnya",
    "previousPage": "Halaman sebelumnya",
    "edit": "Ubah",
    "delete": "Hapus",
    "saved": "Harga vendor disimpan.",
    "deleted": "Harga vendor dihapus.",
    "status": {
      "current": "Berlaku",
      "future": "Akan berlaku",
      "past": "Sudah lewat"
    },
    "form": {
      "newTitle": "Atur harga vendor",
      "editTitle": "Ubah harga vendor",
      "description": "Harga tersimpan dalam rupiah penuh dan berlaku mulai tanggal yang dipilih.",
      "variant": "Varian",
      "channel": "Kanal penjualan",
      "channelDefault": "Semua kanal (harga default)",
      "channelHint": "Kosongkan untuk harga default, atau pilih kanal untuk harga khusus kanal itu.",
      "price": "Harga vendor (Rp)",
      "priceHint": "Rupiah penuh, tanpa titik atau desimal.",
      "suggestedHint": "Diisi dari saran harga vendor (HPP Rp {{cogs}}). Boleh diubah.",
      "effectiveFrom": "Berlaku mulai",
      "effectiveFromHint": "Boleh tanggal lampau atau mendatang, paling awal tanggal adopsi workspace.",
      "required": "Wajib diisi.",
      "priceInvalid": "Isi angka bulat 0 atau lebih.",
      "dateInvalid": "Isi tanggal yang benar.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "confirmDelete": {
      "title": "Hapus harga vendor ini?",
      "body": "Harga ini belum berlaku, jadi bisa dihapus. Harga yang sudah berlaku tidak bisa dihapus — tambahkan harga baru untuk menggantinya.",
      "confirm": "Hapus",
      "cancel": "Batal"
    },
    "errors": {
      "inEffect": "Harga ini sudah berlaku dan tidak bisa diubah atau dihapus. Tambahkan harga baru dengan tanggal berlaku yang lebih baru.",
      "beforeAdoptionDate": "Tanggal berlaku tidak boleh sebelum tanggal adopsi workspace.",
      "adoptionDateNotSet": "Tanggal adopsi workspace belum diisi. Isi dulu di pengaturan workspace.",
      "validationFailed": "Periksa lagi isian: varian, kanal, harga, dan tanggal berlaku. Satu varian hanya boleh punya satu harga per kanal per tanggal.",
      "forbidden": "Hanya Pemilik yang bisa melihat dan mengatur harga vendor."
    },
    "recentChanges": "5 perubahan terakhir",
    "since": "sejak {{date}}",
    "openAll": "Lihat semua harga vendor"
  },
  "materials": {
    "title": "Stok bahan",
    "filament": "Filamen",
    "component": "Komponen",
    "search": "Cari stok bahan",
    "empty": "Belum ada stok bahan di daftar ini.",
    "newPool": "Stok bahan baru",
    "restock": "Belanja bahan",
    "adjustment": "Penyesuaian stok",
    "back": "Kembali ke stok bahan",
    "columns": {
      "pool": "Bahan",
      "qty": "Jumlah",
      "costPerUnit": "Biaya per satuan",
      "totalValue": "Nilai total",
      "minQty": "Minimum"
    },
    "flags": {
      "belowMinimum": "Di bawah minimum",
      "needsStockCount": "Perlu hitung stok",
      "archived": "Diarsipkan"
    },
    "noMinimum": "Tidak diatur",
    "noCost": "—",
    "firstUse": "Belum ada stok bahan yang punya jumlah. Mulai dengan mencatat saldo awal.",
    "firstUseAction": "Catat saldo awal",
    "firstUseScratch": "Belum ada stok bahan yang punya jumlah. Catat belanja bahan untuk mengisi jumlah dan biayanya.",
    "firstUseScratchNoPools": "Belum ada stok bahan. Buat stok bahan untuk tiap filamen dan komponen, lalu catat belanja bahan.",
    "detail": {
      "title": "Detail stok bahan",
      "balance": "Saldo stok",
      "variants": "Varian yang memakai stok bahan ini",
      "variantsEmpty": "Belum ada varian yang memakai stok bahan ini.",
      "variantSlot": "{{model}} · slot {{slot}}"
    },
    "movements": {
      "title": "Mutasi stok",
      "empty": "Belum ada mutasi stok untuk bahan ini.",
      "emptyOwner": "Belum ada mutasi stok. Mulai dengan mencatat saldo awal.",
      "emptyOwnerScratch": "Belum ada mutasi stok. Mulai dengan mencatat belanja bahan.",
      "loadMore": "Muat lebih banyak",
      "loadingMore": "Memuat…",
      "unknownSource": "Mutasi",
      "columns": {
        "date": "Tanggal",
        "type": "Jenis",
        "qty": "Perubahan jumlah",
        "value": "Perubahan nilai",
        "createdBy": "Dicatat oleh"
      },
      "types": {
        "OpeningBalance": "Saldo awal",
        "Restock": "Belanja bahan",
        "Batch": "Batch cetak",
        "Assembly": "Perakitan",
        "Adjustment": "Penyesuaian stok",
        "Dispatch": "Pengiriman",
        "Return": "Retur",
        "SalesReport": "Terjual"
      }
    },
    "form": {
      "newTitle": "Stok bahan baru",
      "editTitle": "Ubah stok bahan",
      "kind": "Jenis",
      "unit": "Satuan",
      "unitG": "gram (g)",
      "unitPcs": "pcs",
      "unitHint": "Satuan mengikuti jenis: filamen dalam gram, komponen dalam pcs.",
      "brand": "Merek",
      "materialType": "Jenis material",
      "productLine": "Lini produk",
      "color": "Warna",
      "name": "Nama",
      "minQty": "Minimum (opsional)",
      "minQtyHint": "Kosongkan kalau tidak perlu peringatan stok menipis.",
      "lockedHint": "Jenis dan satuan terkunci karena stok bahan ini sudah punya mutasi, ada di daftar bahan (BOM), atau dipakai varian.",
      "required": "Wajib diisi.",
      "minQtyInvalid": "Isi angka bulat 0 atau lebih.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal",
      "created": "Stok bahan dibuat.",
      "saved": "Perubahan disimpan."
    },
    "archive": {
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmBody": "Stok bahan ini disembunyikan dari daftar dan pilihan catatan baru. Riwayatnya tetap tersimpan.",
      "confirmValue": "Nilai tersisa Rp {{value}} tetap tercatat di riwayat.",
      "confirmVariants": "{{count}} varian akan Perlu warna: {{variants}}.",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Stok bahan ini muncul lagi di daftar dan pilihan catatan baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip."
    },
    "errors": {
      "poolKeyTaken": "Sudah ada stok bahan lain dengan data yang sama di workspace ini.",
      "poolHasStock": "Jumlahnya belum 0. Hitung stok jadi 0 lewat penyesuaian stok dulu, baru arsipkan.",
      "poolInPrintingBatch": "Stok bahan ini dipakai batch cetak yang sedang berjalan. Selesaikan atau batalkan batch cetak itu dulu.",
      "poolInUse": "Jenis dan satuan tidak bisa diubah karena stok bahan ini sudah punya mutasi, ada di daftar bahan (BOM), atau dipakai varian.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "poolInBom": "Stok bahan ini masih jadi komponen di daftar bahan (BOM) saat ini atau di versi BOM yang belum berlaku. Buat versi BOM baru tanpa komponen ini dulu, baru arsipkan.",
      "openBom": "Buka daftar bahan (BOM) {{code}} · {{name}}"
    },
    "filterKind": "Jenis",
    "filterCondition": "Kondisi",
    "needsAttention": "Perlu perhatian",
    "list": {
      "costPerUnit": "Rp {{amount}}/{{unit}}",
      "totalValue": "Nilai Rp {{amount}}",
      "minimum": "Min. {{qty}}"
    }
  },
  "products": {
    "title": "Produk",
    "search": "Cari kode atau nama produk",
    "statusFilter": "Status",
    "archived": "Diarsipkan",
    "empty": "Belum ada produk di daftar ini.",
    "newProduct": "Produk baru",
    "variantCount": "{{count}} varian",
    "edit": "Ubah produk",
    "back": "Kembali ke produk",
    "status": {
      "in_development": "Dalam pengembangan",
      "active": "Aktif"
    },
    "detail": {
      "title": "Detail produk",
      "tabs": {
        "models": "Model",
        "bom": "Daftar bahan (BOM)",
        "variants": "Varian",
        "cogs": "Ringkasan HPP"
      },
      "empty": {
        "models": "Belum ada model untuk produk ini.",
        "bom": "Belum ada daftar bahan (BOM) untuk produk ini.",
        "variants": "Belum ada varian untuk produk ini."
      },
      "cogs": {
        "title": "Data HPP",
        "targetMargin": "Margin target (%)",
        "targetMarginDefault": "Kosong: memakai margin target di Pengaturan HPP",
        "defaultLaborMinutes": "Menit kerja default per unit",
        "defaultLaborMinutesHint": "Dipakai untuk biaya tenaga kerja sampai produk ini punya data perakitan."
      }
    },
    "form": {
      "newTitle": "Produk baru",
      "editTitle": "Ubah produk",
      "code": "Kode",
      "codeHint": "Huruf A–Z, angka 0–9 dan tanda -, paling banyak 10 karakter. Contoh: DRG.",
      "codeInvalid": "Pakai huruf A–Z, angka 0–9 atau tanda -, paling banyak 10 karakter.",
      "name": "Nama",
      "status": "Status",
      "statusHint": "Status hanya penanda dan tidak membatasi apa pun.",
      "cogs": "Data HPP",
      "targetMargin": "Margin target (%)",
      "targetMarginHint": "Kosongkan untuk memakai margin target di Pengaturan HPP. Harus di bawah 100%.",
      "targetMarginInvalid": "Isi persen 0 sampai di bawah 100, paling banyak dua angka di belakang koma.",
      "defaultLaborMinutes": "Menit kerja default per unit",
      "defaultLaborMinutesHint": "Dipakai untuk biaya tenaga kerja sampai produk ini punya data perakitan. Boleh kosong.",
      "wholeInvalid": "Isi angka bulat 0 atau lebih.",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "archive": {
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmBody": "Produk ini disembunyikan dari daftar dan pilihan catatan baru. Model dan variannya tidak ikut diarsipkan, dan riwayatnya tetap tersimpan.",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Produk ini muncul lagi di daftar dan pilihan catatan baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip."
    },
    "errors": {
      "codeTaken": "Kode ini sudah dipakai produk lain di workspace ini, termasuk produk yang diarsipkan.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "conflict": "Produk ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi."
    },
    "listing": {
      "lead": "Isi listing marketplace untuk produk ini. Salin teksnya dan unduh foto atau video saat memasang produk di Shopee atau marketplace lain.",
      "copy": "Salin {{field}}",
      "copied": "{{field}} disalin",
      "download": "Unduh {{name}}",
      "downloadAll": "Unduh semua (.zip)",
      "save": "Simpan listing",
      "uploading": "Mengunggah…",
      "counter": "{{length}} / {{max}} karakter",
      "overShopee": "{{length}} karakter, lebih dari batas Shopee ({{max}}).",
      "tooLong": "Maksimal {{max}} karakter.",
      "wholeInvalid": "Isi bilangan bulat lebih dari 0, atau kosongkan.",
      "brandHint": "Diatur Pemilik di Pengaturan workspace.",
      "conditionNew": "Baru",
      "fields": {
        "listing_title": "Judul listing",
        "listing_description": "Deskripsi",
        "marketplace_category": "Kategori marketplace",
        "package_weight_g": "Berat paket (gram)",
        "package_length_cm": "Panjang paket (cm)",
        "package_width_cm": "Lebar paket (cm)",
        "package_height_cm": "Tinggi paket (cm)",
        "brand": "Merek",
        "condition": "Kondisi"
      },
      "photos": {
        "title": "Foto ({{count}}/{{max}})",
        "empty": "Belum ada foto. Foto pertama jadi foto sampul.",
        "cover": "Sampul",
        "add": "Tambah foto",
        "hint": "File .jpg, .png atau .webp. Tridi membuat salinan persegi 1024×1024 berlatar putih untuk diunduh.",
        "limit": "Listing sudah punya 9 foto, batas Shopee. Hapus satu foto dulu.",
        "moveLeft": "Geser foto ke kiri",
        "moveRight": "Geser foto ke kanan",
        "remove": "Hapus foto",
        "confirmRemove": "Hapus foto ini? Foto tidak bisa dikembalikan."
      },
      "video": {
        "title": "Video",
        "empty": "Belum ada video.",
        "add": "Tambah video",
        "replace": "Ganti video",
        "hint": "Satu file .mp4, maksimal 100 MB. Shopee menerima maksimal 30 MB.",
        "overShopee": "Lebih dari 30 MB, batas video Shopee.",
        "download": "Unduh video",
        "remove": "Hapus video",
        "confirmRemove": "Hapus video ini? Video tidak bisa dikembalikan."
      },
      "variants": {
        "title": "Variasi",
        "empty": "Produk ini belum punya varian.",
        "channel": "Harga untuk kanal",
        "defaultPrice": "Harga vendor default",
        "sku": "SKU",
        "stock": "Stok di rumah",
        "price": "Harga",
        "suggested": "Saran harga",
        "noPhoto": "Tanpa foto",
        "addPhoto": "Tambah foto",
        "replacePhoto": "Ganti foto",
        "removePhoto": "Hapus foto variasi"
      }
    }
  },
  "models": {
    "title": "Model",
    "newModel": "Model baru",
    "edit": "Ubah model",
    "back": "Kembali ke produk",
    "archived": "Diarsipkan",
    "slotCount": "Slot warna: {{count}}",
    "yield": {
      "label": "Tingkat berhasil",
      "percent": "{{percent}}%",
      "parts": "{{ok}} OK dari {{printed}} part dicetak",
      "none": "—",
      "hint": "Tingkat berhasil = part OK ÷ part dicetak, dari batch cetak produksi yang selesai dan tidak dianulir, semua versi.",
      "topFailureReasons": "Alasan gagal teratas",
      "reason": "{{reason}} ({{failed}})"
    },
    "created": "Model {{name}} dibuat.",
    "detail": {
      "title": "Detail model",
      "slots": "Slot warna",
      "versions": "Versi model"
    },
    "form": {
      "newTitle": "Model baru",
      "editTitle": "Ubah model",
      "description": "Model adalah satu bagian yang dicetak dari produk ini. Setiap model punya minimal satu slot warna.",
      "name": "Nama model",
      "namePlaceholder": "Contoh: badan, alas",
      "slots": "Slot warna",
      "slotsHint": "Kunci slot diambil dari label pertama (huruf kecil) dan tidak berubah saat label diganti.",
      "slotLabel": "Label slot warna {{n}}",
      "newSlotLabel": "Slot warna baru",
      "slotLimit": "Paling banyak {{max}} slot warna per model, termasuk yang diarsipkan.",
      "addSlot": "Tambah slot warna",
      "removeSlot": "Buang",
      "required": "Wajib diisi.",
      "create": "Buat model",
      "save": "Simpan",
      "saving": "Menyimpan…"
    },
    "slots": {
      "key": "Kunci",
      "label": "Label slot warna {{key}}",
      "rename": "Simpan label",
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip"
    },
    "archive": {
      "archive": "Arsipkan model",
      "unarchive": "Kembalikan model dari arsip",
      "archiveHint": "Model yang diarsipkan disembunyikan dari pilihan catatan baru; riwayatnya tetap tersimpan.",
      "unarchiveHint": "Model ini diarsipkan. Kembalikan agar muncul lagi di pilihan catatan baru.",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Model ini muncul lagi di pilihan catatan baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip."
    },
    "errors": {
      "slotKeyTaken": "Model ini sudah punya slot warna dengan nama ini, termasuk slot yang diarsipkan. Kembalikan slot itu dari arsip, atau pakai nama lain.",
      "slotLimitReached": "Model ini sudah punya 10 slot warna (termasuk yang diarsipkan), jadi tidak bisa ditambah lagi.",
      "lastActiveSlot": "Ini slot warna aktif terakhir model ini. Tambahkan slot warna lain dulu, baru arsipkan slot ini.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "conflict": "Model ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi.",
      "slotInUse": "Versi model saat ini memakai slot warna ini. Buat versi model baru tanpa slot ini dulu, baru arsipkan slotnya.",
      "inBom": "Model ini ada di daftar bahan (BOM) saat ini atau di versi BOM yang belum berlaku. Buat versi BOM baru tanpa model ini dulu, baru arsipkan modelnya."
    }
  },
  "modelVersions": {
    "title": "Versi model",
    "upload": "Unggah versi",
    "versionNo": "v{{no}}",
    "current": "Versi saat ini",
    "breaking": "Versi tidak kompatibel",
    "noFiles": "Belum ada file .3mf / .stl, belum bisa dipakai untuk batch cetak",
    "archived": "Diarsipkan",
    "showArchived": "Tampilkan yang diarsipkan",
    "empty": "Belum ada versi model.",
    "back": "Kembali ke model",
    "summary": "{{parts}} part per pelat · {{minutes}} menit per pelat",
    "slotGrams": "{{label}}: {{grams}} g",
    "recipe": {
      "title": "Resep cetak",
      "partsPerPlate": "Part per pelat",
      "estMinutesPerPlate": "Perkiraan menit cetak per pelat",
      "profileName": "Nama profil",
      "nozzle": "Nozzle",
      "slots": "Slot warna yang dipakai",
      "estGramsPerPlate": "Perkiraan gram per pelat",
      "gramsUnit": "{{grams}} g",
      "minutesUnit": "{{minutes}} menit",
      "empty": "—"
    },
    "files": {
      "title": "File",
      "hint": "File .3mf, .stl, .png, .jpg atau .webp, paling besar 100 MB per file. Minimal satu .3mf / .stl agar versi bisa dipakai untuk batch cetak.",
      "pick": "Pilih file",
      "empty": "Belum ada file.",
      "uploading": "Mengunggah… {{percent}}%",
      "verifying": "Memeriksa file…",
      "ready": "Siap disimpan",
      "attached": "Tersimpan",
      "sizeKb": "{{size}} KB",
      "sizeMb": "{{size}} MB",
      "download": "Unduh",
      "downloadFile": "Unduh {{filename}}",
      "remove": "Hapus file",
      "removeFile": "Hapus {{filename}}",
      "removeConfirmTitle": "Hapus {{filename}}?",
      "removeConfirmBody": "File dihapus dari penyimpanan. Kalau ini file .3mf / .stl terakhir, versi ini tidak bisa dipakai untuk batch cetak baru.",
      "removeCancel": "Batal",
      "removeConfirm": "Hapus",
      "removed": "{{filename}} dihapus.",
      "someFailed": "Versi tersimpan, tapi sebagian file gagal disimpan. Buka versi ini untuk menambahkannya lagi.",
      "openVersion": "Buka versi"
    },
    "form": {
      "newTitle": "Unggah versi model",
      "description": "Tambahkan file .3mf / .stl (dan gambar bila perlu) serta resep cetaknya. File juga bisa ditambahkan nanti di detail versi. Versi tanpa file .3mf / .stl belum bisa dipakai untuk batch cetak.",
      "notes": "Catatan (opsional)",
      "breaking": "Versi tidak kompatibel",
      "breakingHint": "Part WIP dari versi sebelumnya ditampilkan terpisah (pra-versi ini) dan tidak bisa dirakit. Hanya bisa diatur saat versi dibuat.",
      "optional": "{{label}} (opsional)",
      "slotsHint": "Pilih slot warna model yang dipakai versi ini, lalu isi perkiraan gram per pelat. Minimal satu slot.",
      "slotUsed": "Pakai slot {{label}}",
      "slotArchived": "Slot diarsipkan",
      "slotsRequired": "Pilih minimal satu slot warna yang tidak diarsipkan.",
      "wholeNumber": "Isi bilangan bulat lebih dari 0.",
      "invalidField": "Periksa kembali isian ini.",
      "create": "Simpan versi",
      "save": "Simpan resep cetak",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail versi model",
      "heading": "{{model}} v{{no}}",
      "notes": "Catatan",
      "noNotes": "Tidak ada catatan.",
      "editNotes": "Ubah catatan",
      "saveNotes": "Simpan catatan",
      "editRecipe": "Ubah resep cetak",
      "editRecipeHint": "Perubahan resep cetak dicatat di riwayat. Batch yang sudah tercatat menyimpan angkanya sendiri.",
      "recipeSaved": "Resep cetak disimpan.",
      "notFound": "Versi model ini tidak ditemukan.",
      "batches": "Batch cetak yang memakai versi ini",
      "noBatches": "Belum ada batch cetak yang memakai versi ini."
    },
    "archive": {
      "archive": "Arsipkan versi",
      "unarchive": "Kembalikan versi dari arsip",
      "archiveHint": "Versi yang diarsipkan disembunyikan dari batch cetak baru; riwayatnya tetap tersimpan. Versi saat ini menjadi versi tertinggi yang tidak diarsipkan.",
      "unarchiveHint": "Versi ini diarsipkan. Kembalikan agar bisa dipakai lagi.",
      "confirmTitle": "Arsipkan v{{no}}?",
      "confirmUnarchiveTitle": "Kembalikan v{{no}} dari arsip?",
      "confirmUnarchiveBody": "Versi ini bisa dipakai lagi. Kalau nomornya paling tinggi, versi ini menjadi versi saat ini.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "v{{no}} diarsipkan.",
      "unarchived": "v{{no}} kembali dari arsip."
    },
    "errors": {
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda. Slot warna yang diarsipkan tidak bisa ditambahkan, dan model atau produk yang diarsipkan tidak bisa diberi versi baru.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "conflict": "Model ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi."
    }
  },
  "boms": {
    "title": "Daftar bahan (BOM)",
    "back": "Kembali ke produk",
    "open": "Lihat semua versi BOM",
    "newVersion": "Versi BOM baru",
    "current": "Berlaku sekarang",
    "upcoming": "Belum berlaku",
    "history": "Riwayat versi",
    "noCurrent": "Belum ada versi BOM yang berlaku hari ini.",
    "effectiveFrom": "Berlaku mulai {{date}}",
    "status": {
      "current": "Berlaku sekarang",
      "future": "Belum berlaku",
      "past": "Tidak berlaku lagi"
    },
    "kind": {
      "model": "Model",
      "component": "Komponen"
    },
    "qty": "× {{qty}} per unit",
    "archivedItem": "Diarsipkan",
    "edit": "Ubah versi",
    "saved": "Versi BOM disimpan.",
    "form": {
      "newTitle": "Versi BOM baru",
      "effectiveFrom": "Berlaku mulai",
      "effectiveFromHint": "Hari ini atau sesudahnya.",
      "effectiveFromEarliestHint": "Hari ini atau sesudahnya. Versi yang lebih awal dari semua versi lain produk ini boleh berlaku mulai {{from}} (tanggal mulai pakai) sampai sebelum {{before}}.",
      "finalHint": "Versi yang berlaku hari ini atau lebih awal langsung final; setelah itu hanya versi BOM baru yang bisa mengubahnya.",
      "lines": "Isi per unit",
      "item": "Model atau komponen",
      "selectItem": "Pilih model atau komponen",
      "models": "Model",
      "components": "Komponen",
      "qty": "Jumlah per unit",
      "addLine": "Tambah baris",
      "removeLine": "Buang",
      "archivedOption": "{{name}} (Diarsipkan)",
      "archivedPick": "Yang ini sudah diarsipkan. Pilih model atau komponen lain.",
      "modelRequired": "Tambahkan minimal satu model.",
      "duplicate": "Model atau komponen ini sudah ada di daftar.",
      "required": "Wajib diisi.",
      "wholeNumber": "Isi bilangan bulat lebih dari 0.",
      "save": "Simpan versi",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "delete": {
      "delete": "Hapus versi",
      "confirmTitle": "Hapus versi BOM yang berlaku mulai {{date}}?",
      "confirmBody": "Versi ini belum berlaku, jadi bisa dihapus beserta isinya.",
      "confirm": "Hapus",
      "cancel": "Batal",
      "deleted": "Versi BOM dihapus."
    },
    "errors": {
      "inEffect": "Versi BOM ini sudah berlaku, jadi tidak bisa diubah atau dihapus. Buat versi BOM baru.",
      "tooEarly": "Tanggal berlaku terlalu awal. Paling awal {{date}}.",
      "tooEarlyWithBackdate": "Tanggal berlaku harus {{date}} atau sesudahnya, atau antara {{from}} dan sebelum {{before}} untuk versi yang lebih awal dari semua versi lain.",
      "lineLimitReached": "Satu versi BOM paling banyak {{max}} baris.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "conflict": "Versi BOM ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda. Setiap versi butuh minimal satu model, tanggalnya belum dipakai versi lain, dan model atau komponen yang diarsipkan tidak bisa dipakai.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    }
  },
  "variants": {
    "title": "Varian",
    "newVariant": "Varian baru",
    "edit": "Ubah varian",
    "back": "Kembali ke produk",
    "archived": "Diarsipkan",
    "needsColor": "Perlu warna",
    "saved": "Varian disimpan.",
    "form": {
      "newTitle": "Varian baru",
      "editTitle": "Ubah varian",
      "name": "Nama varian",
      "nameHint": "Contoh: Merah. Tidak boleh sama dengan varian lain di produk ini.",
      "sku": "SKU",
      "skuHint": "Huruf A–Z, angka 0–9 dan tanda -, paling banyak 20 karakter. Contoh: DRG-RED.",
      "skuInvalid": "Pakai huruf A–Z, angka 0–9 atau tanda -, paling banyak 20 karakter.",
      "slots": "Stok bahan per slot warna",
      "slotsHint": "Pilih filamen untuk setiap slot warna. Slot yang belum diisi ditandai Perlu warna, dan varian tetap bisa disimpan.",
      "noSlots": "Produk ini belum punya model dengan slot warna aktif.",
      "selectPool": "Belum dipilih",
      "archivedOption": "{{name}} (Diarsipkan)",
      "archivedPick": "Stok bahan ini sudah diarsipkan. Pilih filamen lain.",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal",
      "remapTitle": "Ganti stok bahan?",
      "remapBody": "Anda mengganti stok bahan untuk slot warna yang sudah terisi: {{slots}}. Perubahan ini dicatat di riwayat. Part yang sudah dicetak dengan stok bahan lama tetap terpisah: tidak dihitung dalam Bisa dirakit, tapi bisa dipilih sebagai Pengganti saat perakitan.",
      "remapConfirm": "Ganti dan simpan",
      "remapCancel": "Batal"
    },
    "archive": {
      "archive": "Arsipkan",
      "unarchive": "Kembalikan dari arsip",
      "confirmTitle": "Arsipkan {{name}}?",
      "confirmBody": "Varian ini disembunyikan dari pilihan batch cetak dan perakitan baru. Stok yang tersisa tetap bisa dikirim, diretur dan dijual sampai habis, dan riwayatnya tetap tersimpan.",
      "confirmUnarchiveTitle": "Kembalikan {{name}} dari arsip?",
      "confirmUnarchiveBody": "Varian ini muncul lagi di pilihan catatan baru.",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "archived": "{{name}} diarsipkan.",
      "unarchived": "{{name}} kembali dari arsip."
    },
    "errors": {
      "skuTaken": "SKU ini sudah dipakai varian lain di workspace ini, termasuk varian yang diarsipkan.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "invalidTransition": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
      "validationFailed": "Periksa lagi isian Anda. Nama varian tidak boleh sama dengan varian lain produk ini, dan setiap slot harus memakai filamen yang belum diarsipkan.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini.",
      "conflict": "Varian ini sedang diubah bersamaan dengan permintaan lain. Muat ulang halaman, lalu coba lagi."
    }
  },
  "restocks": {
    "title": "Belanja bahan",
    "new": "Belanja bahan baru",
    "back": "Kembali ke belanja bahan",
    "empty": "Belum ada belanja bahan.",
    "emptyMonth": "Belum ada belanja bahan di bulan ini.",
    "filterMonth": "Bulan",
    "noVendor": "—",
    "lineCount_other": "{{count}} bahan",
    "columns": {
      "date": "Tanggal",
      "vendor": "Penjual",
      "lines": "Isi",
      "total": "Total",
      "createdBy": "Dicatat oleh"
    },
    "form": {
      "title": "Belanja bahan baru",
      "date": "Tanggal",
      "dateHint": "Hari ini atau sebelumnya, dan tidak sebelum tanggal mulai pakai.",
      "backdateReason": "Alasan mundur tanggal",
      "backdateReasonHint": "Alasan ini disimpan di riwayat catatan.",
      "vendor": "Penjual (opsional)",
      "note": "Catatan (opsional)",
      "lines": "Baris",
      "pool": "Bahan",
      "selectPool": "Pilih bahan",
      "qty": "Jumlah",
      "amount": "Total harga baris (Rp)",
      "costPerUnit": "Biaya per satuan",
      "total": "Total belanja",
      "addLine": "Tambah baris",
      "removeLine": "Hapus baris",
      "expenseHint": "Belanja ini otomatis jadi satu pengeluaran sebesar total di atas.",
      "shippingHint": "Ongkir dicatat sebagai pengeluaran terpisah dan tidak masuk ke biaya per satuan.",
      "noPools": "Belum ada stok bahan. Buat stok bahan dulu.",
      "goToPools": "Buka stok bahan",
      "required": "Wajib diisi.",
      "qtyInvalid": "Isi angka bulat lebih dari 0.",
      "amountInvalid": "Isi angka bulat 0 atau lebih.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail belanja bahan",
      "note": "Catatan",
      "noNote": "—",
      "expense": "Pengeluaran",
      "category": "Kategori",
      "expenseCategory": "Belanja bahan",
      "expenseReadOnly": "Pengeluaran ini hanya berubah kalau belanja bahannya dianulir.",
      "movements": "Mutasi stok"
    },
    "errors": {
      "adoptionDateNotSet": "Isi tanggal mulai pakai dulu di pengaturan workspace.",
      "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal tidak boleh setelah hari ini.",
      "backdateLimitExceeded": "Tanggal lebih dari {{days}} hari ke belakang. Minta Pemilik yang mencatatnya.",
      "backdateReasonRequired": "Tanggal lebih dari {{days}} hari ke belakang. Isi alasannya dulu.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    }
  },
  "adjustments": {
    "title": "Penyesuaian stok",
    "new": "Penyesuaian stok baru",
    "back": "Kembali ke penyesuaian stok",
    "empty": "Belum ada penyesuaian stok.",
    "lineCount_other": "{{count}} bahan",
    "lineCountWip_other": "{{count}} part",
    "lineCountVariant_other": "{{count}} varian",
    "preVnNow": "pre-vN saat ini",
    "preVnNowHint": "Status pre-vN part ini sekarang, bukan saat penyesuaian dicatat.",
    "columns": {
      "date": "Tanggal",
      "location": "Lokasi",
      "reason": "Alasan",
      "lines": "Isi",
      "createdBy": "Dicatat oleh"
    },
    "locations": {
      "materials": "Stok bahan",
      "wip": "Part belum dirakit (WIP)",
      "home": "Gudang",
      "channel": "Kanal penjualan"
    },
    "reasons": {
      "count": "Hitung stok",
      "damaged": "Rusak",
      "lost": "Hilang",
      "write_off": "Dihapusbukukan",
      "unused_part": "Komponen tidak terpakai",
      "revalue": "Koreksi nilai"
    },
    "form": {
      "title": "Penyesuaian stok baru",
      "date": "Tanggal",
      "dateHint": "Hari ini atau sebelumnya, dan tidak sebelum tanggal mulai pakai.",
      "backdateReason": "Alasan mundur tanggal",
      "backdateReasonHint": "Alasan ini disimpan di riwayat catatan.",
      "reason": "Alasan",
      "note": "Catatan",
      "noteOptional": "Catatan (opsional)",
      "noteHint": "Wajib diisi untuk rusak, hilang, dan dihapusbukukan.",
      "lines": "Baris",
      "pool": "Bahan",
      "selectPool": "Pilih bahan",
      "wipItem": "Part",
      "selectWipItem": "Pilih part",
      "variant": "Varian",
      "selectVariant": "Pilih varian",
      "channel": "Kanal penjualan",
      "currentQty": "Jumlah tercatat",
      "mode": "Cara isi",
      "modeCounted": "Hasil hitung",
      "modeDelta": "Selisih",
      "countedQty": "Hasil hitung",
      "qtyDelta": "Selisih (+/−)",
      "newQty": "Jumlah setelah",
      "valueChange": "Perubahan nilai",
      "addLine": "Tambah baris",
      "removeLine": "Hapus baris",
      "noPools": "Belum ada stok bahan. Buat stok bahan dulu.",
      "goToPools": "Buka stok bahan",
      "noWipItems": "Belum ada part di WIP.",
      "noVariants": "Belum ada varian. Buat produk dan variannya dulu.",
      "noChannels": "Belum ada kanal penjualan.",
      "required": "Wajib diisi.",
      "countedQtyInvalid": "Isi angka bulat 0 atau lebih.",
      "qtyDeltaInvalid": "Isi angka bulat, boleh minus.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail penyesuaian stok",
      "note": "Catatan",
      "noNote": "—",
      "movements": "Mutasi stok"
    },
    "errors": {
      "adoptionDateNotSet": "Isi tanggal mulai pakai dulu di pengaturan workspace.",
      "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal tidak boleh setelah hari ini.",
      "backdateLimitExceeded": "Tanggal lebih dari {{days}} hari ke belakang. Minta Pemilik yang mencatatnya.",
      "backdateReasonRequired": "Tanggal lebih dari {{days}} hari ke belakang. Isi alasannya dulu.",
      "nothingToCount": "Belum ada stok untuk dihitung. Gunakan saldo awal atau restock.",
      "costPerUnitRequired": "Stok bahan ini belum punya biaya per satuan. Catat lewat Belanja bahan, atau minta Pemilik mengisi biaya per satuan lewat Claude (Koreksi nilai).",
      "nothingToCountWip": "Part ini belum pernah masuk WIP, jadi belum ada yang dihitung. Gunakan saldo awal WIP.",
      "nothingToCountVariant": "Varian ini belum pernah masuk ke lokasi ini, jadi belum ada yang dihitung. Gunakan saldo awal.",
      "salesChannelArchived": "Channel ini sudah diarsipkan. Hanya koreksi yang mengurangi stoknya yang bisa dicatat.",
      "wouldGoNegative": "Part belum dirakit (WIP) tidak boleh minus. Periksa lagi hasil hitung atau selisihnya.",
      "wouldGoNegativeVariant": "Stok barang jadi tidak boleh minus. Periksa lagi hasil hitung atau selisihnya.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    }
  },
  "dispatches": {
    "title": "Pengiriman",
    "new": "Pengiriman baru",
    "back": "Kembali ke pengiriman",
    "empty": "Belum ada pengiriman.",
    "emptyFiltered": "Tidak ada pengiriman yang cocok dengan filter.",
    "units_other": "{{count}} pcs",
    "columns": {
      "date": "Tanggal",
      "channel": "Kanal penjualan",
      "units": "Jumlah",
      "createdBy": "Dicatat oleh"
    },
    "form": {
      "title": "Pengiriman baru",
      "channel": "Kanal penjualan",
      "date": "Tanggal",
      "dateHint": "Hari ini atau sebelumnya, dan tidak sebelum tanggal mulai pakai.",
      "backdateReason": "Alasan mundur tanggal",
      "backdateReasonHint": "Alasan ini disimpan di riwayat catatan.",
      "variant": "Varian",
      "selectVariant": "Pilih varian",
      "qty": "Jumlah (pcs)",
      "homeStock": "Stok di gudang: {{qty}} pcs",
      "aboveHome": "Lebih banyak dari stok di gudang ({{qty}} pcs). Sesuaikan stok gudang dulu.",
      "qtyInvalid": "Isi angka bulat 1 atau lebih.",
      "note": "Catatan (opsional)",
      "addLine": "Tambah baris",
      "removeLine": "Hapus baris",
      "noChannels": "Belum ada kanal penjualan aktif. Buat kanal penjualan dulu.",
      "noVariants": "Belum ada varian untuk dikirim.",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail pengiriman",
      "lines": "Isi pengiriman",
      "movements": "Mutasi stok",
      "home": "Gudang",
      "print": "Surat jalan"
    },
    "print": {
      "title": "Surat jalan",
      "back": "Kembali ke detail pengiriman",
      "print": "Cetak",
      "sku": "SKU",
      "name": "Nama",
      "qty": "Jumlah (pcs)",
      "total": "Total unit",
      "toAdjustment": "Sesuaikan stok di gudang"
    },
    "errors": {
      "adoptionDateNotSet": "Tanggal mulai pakai belum diisi. Isi dulu di pengaturan.",
      "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal tidak boleh di masa depan.",
      "backdateLimitExceeded": "Tanggal lebih dari {{days}} hari ke belakang.",
      "backdateReasonRequired": "Tanggal lebih dari {{days}} hari ke belakang. Isi alasannya.",
      "wouldGoNegative": "Stok di gudang tidak cukup: {{items}}. Sesuaikan stok gudang dulu.",
      "blockingItem": "{{label}} (sisa {{qty}} pcs)",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "list": {
      "lines": "{{count}} baris"
    }
  },
  "returns": {
    "title": "Retur",
    "new": "Retur baru",
    "back": "Kembali ke retur",
    "empty": "Belum ada retur.",
    "emptyFiltered": "Tidak ada retur yang cocok dengan filter.",
    "units_other": "{{count}} pcs",
    "columns": {
      "date": "Tanggal",
      "channel": "Kanal penjualan",
      "units": "Jumlah",
      "createdBy": "Dicatat oleh"
    },
    "form": {
      "title": "Retur baru",
      "channel": "Kanal penjualan",
      "date": "Tanggal",
      "dateHint": "Hari ini atau sebelumnya, dan tidak sebelum tanggal mulai pakai.",
      "backdateReason": "Alasan mundur tanggal",
      "backdateReasonHint": "Alasan ini disimpan di riwayat catatan.",
      "variant": "Varian",
      "selectVariant": "Pilih varian",
      "qty": "Jumlah (pcs)",
      "channelStock": "Stok di kanal: {{qty}} pcs",
      "aboveChannel": "Lebih banyak dari stok di kanal ({{qty}} pcs). Sesuaikan stok kanal dulu.",
      "qtyInvalid": "Isi angka bulat 1 atau lebih.",
      "note": "Catatan (opsional)",
      "addLine": "Tambah baris",
      "removeLine": "Hapus baris",
      "toAdjustment": "Sesuaikan stok di kanal",
      "noChannels": "Belum ada kanal penjualan yang menyimpan stok.",
      "noVariants": "Belum ada varian untuk diretur.",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal"
    },
    "detail": {
      "title": "Detail retur",
      "lines": "Isi retur",
      "movements": "Mutasi stok",
      "home": "Gudang"
    },
    "errors": {
      "adoptionDateNotSet": "Tanggal mulai pakai belum diisi. Isi dulu di pengaturan.",
      "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
      "futureDate": "Tanggal tidak boleh di masa depan.",
      "backdateLimitExceeded": "Tanggal lebih dari {{days}} hari ke belakang.",
      "backdateReasonRequired": "Tanggal lebih dari {{days}} hari ke belakang. Isi alasannya.",
      "wouldGoNegative": "Stok di kanal tidak cukup: {{items}}. Sesuaikan stok kanal dulu.",
      "blockingItem": "{{label}} (sisa {{qty}} pcs)",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    },
    "list": {
      "lines": "{{count}} baris"
    }
  },
  "stock": {
    "title": "Barang jadi",
    "search": "Cari SKU atau nama varian",
    "empty": "Belum ada varian.",
    "loadMore": "Muat lebih banyak",
    "loadingMore": "Memuat…",
    "archived": "Diarsipkan",
    "needsColor": "Perlu warna",
    "withSubstitutes": "+{{count}} dengan pengganti",
    "columns": {
      "variant": "Varian",
      "buildable": "Bisa dirakit",
      "home": "Gudang",
      "channels": "Stok di kanal",
      "total": "Total"
    },
    "reasons": {
      "no_bom": "Belum ada BOM yang berlaku",
      "variant_archived": "Varian diarsipkan",
      "product_archived": "Produk diarsipkan"
    },
    "wip": {
      "title": "Part belum dirakit (WIP)",
      "empty": "Belum ada part di WIP.",
      "qty": "Jumlah",
      "preVn": "pre-vN",
      "preVnHint": "Dicetak sebelum versi tidak kompatibel: hanya bisa disesuaikan atau dihapusbukukan.",
      "unusedPart": "Part tidak terpakai",
      "unusedPartHint": "Model ini tidak ada di BOM yang berlaku hari ini.",
      "adjust": "Sesuaikan / hapusbukukan"
    },
    "movements": {
      "title": "Mutasi stok",
      "empty": "Belum ada mutasi stok.",
      "emptyFiltered": "Tidak ada mutasi yang cocok dengan filter ini.",
      "open": "Buka catatan",
      "reversal": "Pembalik mutasi",
      "voided": "Dibatalkan",
      "item": "Barang",
      "columns": {
        "change": "Perubahan",
        "location": "Lokasi",
        "qty": "Perubahan jumlah",
        "value": "Perubahan nilai",
        "createdBy": "Dicatat oleh"
      },
      "filters": {
        "location": "Jenis lokasi",
        "locationId": "Lokasi",
        "sourceType": "Jenis",
        "all": "Semua",
        "clearItem": "Hapus filter barang"
      },
      "locations": {
        "materials": "Stok bahan",
        "wip": "Part belum dirakit (WIP)",
        "home": "Gudang",
        "channel": "Stok di kanal"
      }
    },
    "detail": {
      "back": "Kembali ke barang jadi",
      "stock": "Stok",
      "assemble": "Rakit",
      "edit": "Ubah varian"
    },
    "limiting": "{{label}}: {{available}} tersedia, {{needed}} dibutuhkan per unit"
  },
  "corrections": {
    "void": "Anulir",
    "voided": "Dianulir",
    "voidTitle": "Anulir catatan ini?",
    "voidDescription": "Anulir membalik semua mutasi stok catatan ini dan tidak bisa dibatalkan. Catat ulang dengan data yang benar setelahnya.",
    "reason": "Alasan anulir",
    "reasonHint": "Wajib diisi dan disimpan di riwayat catatan.",
    "reasonRequired": "Wajib diisi.",
    "confirm": "Anulir",
    "saving": "Menyimpan…",
    "cancel": "Batal",
    "voidedBy": "Dianulir oleh",
    "voidedOn": "Tanggal anulir",
    "reversalOf": "Pembalik mutasi #{{id}}",
    "note": "Catatan",
    "noNote": "—",
    "editNote": "Ubah catatan",
    "notePlaceholder": "Catatan (opsional)",
    "save": "Simpan",
    "dependentRecords": "Anulir dulu catatan berikut (terbaru dulu):",
    "dependentRecord": "{{type}} #{{id}} · {{date}}",
    "blockingItem": "{{label}} (sisa {{qty}} pcs)",
    "recordTypes": {
      "Assembly": "Perakitan",
      "Adjustment": "Penyesuaian stok",
      "other": "Catatan",
      "Dispatch": "Pengiriman",
      "Return": "Retur",
      "SalesReport": "Laporan penjualan"
    },
    "errors": {
      "invalidTransition": "Catatan ini sudah dianulir.",
      "staleRecord": "Data sudah berubah. Muat ulang halaman ini dulu.",
      "postedRecordReadonly": "Catatan yang sudah diposting hanya bisa diubah catatannya.",
      "wouldGoNegative": "Stok akan jadi minus. Anulir catatan yang lebih baru dulu.",
      "validationFailed": "Periksa lagi isian Anda.",
      "forbidden": "Anda tidak punya akses untuk tindakan ini."
    }
  },
  "history": {
    "title": "Riwayat",
    "empty": "Belum ada riwayat.",
    "system": "Sistem",
    "reason": "Alasan",
    "noValue": "—",
    "actions": {
      "void": "Dianulir",
      "note_edit": "Catatan diubah",
      "archived": "Diarsipkan",
      "unarchived": "Dikembalikan dari arsip",
      "pool_key_edit": "Nama stok bahan diubah",
      "backdate_override": "Dicatat mundur melewati batas",
      "pool_remap": "Stok bahan diganti",
      "recipe_edit": "Resep cetak diubah",
      "failure_reason_edit": "Alasan gagal diubah",
      "machine_rate_change": "Data tarif mesin diubah",
      "settlement_edit": "Jumlah setoran diubah",
      "expense_edit": "Pengeluaran diubah",
      "expense_delete": "Pengeluaran dihapus",
      "setting_change": "Pengaturan HPP diubah"
    },
    "withSubject": "{{action}}: {{subject}}",
    "subjects": {
      "model_slot": "{{model}} · slot warna {{slot}}",
      "payment": "Pembayaran {{slot}}"
    },
    "fieldWithLabel": "{{field}} ({{label}})",
    "fields": {
      "brand": "Merek",
      "material_type": "Jenis material",
      "product_line": "Lini produk",
      "color": "Warna",
      "name": "Nama",
      "note": "Catatan",
      "archived_at": "Diarsipkan",
      "voided_at": "Dianulir",
      "occurred_on": "Tanggal",
      "pool": "Stok bahan",
      "parts_per_plate": "Part per pelat",
      "est_minutes_per_plate": "Perkiraan menit cetak per pelat",
      "profile_name": "Nama profil",
      "nozzle": "Nozzle",
      "est_grams_per_plate": "Perkiraan gram per pelat",
      "failure_reason": "Alasan gagal",
      "purchase_price": "Harga beli (Rp)",
      "lifetime_hours": "Umur pakai (jam)",
      "watts": "Daya (watt)",
      "settlement_amount": "Jumlah setoran (Rp)",
      "difference_note": "Catatan selisih",
      "amount": "Jumlah (Rp)",
      "vendor": "Penjual",
      "expense_category_id": "Kategori pengeluaran",
      "deleted_at": "Dihapus",
      "labor_rate_per_hour": "Tarif tenaga kerja / jam (Rp)",
      "electricity_price_per_kwh": "Harga listrik / kWh (Rp)",
      "maintenance_bps": "Biaya perawatan (%)",
      "target_margin_bps": "Margin target (%)",
      "default_yield_bps": "Yield default (%)"
    }
  },
  "exports": {
    "csv": "Unduh CSV",
    "csvHint": "Isinya mengikuti filter yang sedang dipakai.",
    "salesReports": "Unduh CSV laporan",
    "payments": "Unduh CSV pembayaran"
  },
  "settings": {
    "workspace": {
      "title": "Pengaturan workspace"
    },
    "adoption": {
      "title": "Tanggal mulai pakai",
      "explanation": "Tanggal saat Tridi mulai jadi catatan resmi usaha Anda. Selama tanggal ini kosong, belum ada catatan yang bisa diposting, dan tidak ada catatan yang boleh bertanggal sebelum tanggal ini.",
      "label": "Tanggal mulai pakai",
      "hint": "Hari ini atau sebelumnya. Kosongkan lalu simpan untuk menghapus tanggal. Tanggal hanya bisa diubah selama belum ada catatan yang diposting.",
      "empty": "Belum diisi",
      "locked": "Tanggal ini terkunci karena sudah ada catatan yang diposting.",
      "inFuture": "Tanggal tidak boleh setelah hari ini.",
      "invalid": "Tanggal tidak valid. Pilih hari ini atau sebelumnya.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "saved": "Tanggal mulai pakai disimpan."
    },
    "openingBalances": {
      "title": "Saldo awal",
      "explanation": "Jumlah dan nilai stok bahan, serta jumlah part belum dirakit (WIP), yang sudah ada saat Anda mulai pakai Tridi. Bertanggal sama dengan tanggal mulai pakai, dan hanya bisa dicatat sebelum bahan atau part itu punya mutasi lain. Saldo awal bukan pengeluaran.",
      "new": "Saldo awal baru",
      "empty": "Belum ada saldo awal.",
      "back": "Kembali ke saldo awal",
      "noAdoptionDate": "Isi tanggal mulai pakai dulu. Selama tanggal itu kosong, belum ada catatan yang bisa diposting.",
      "goToAdoption": "Buka pengaturan workspace",
      "lineCount_other": "{{count}} bahan",
      "wipLineCount_other": "{{count}} part",
      "variantLineCount_other": "{{count}} varian",
      "locations": {
        "materials": "Bahan",
        "wip": "Part belum dirakit (WIP)",
        "home": "Gudang",
        "channel": "Kanal penjualan"
      },
      "columns": {
        "date": "Tanggal",
        "location": "Lokasi",
        "lines": "Isi",
        "totalValue": "Nilai total",
        "createdBy": "Dicatat oleh"
      },
      "detail": {
        "title": "Detail saldo awal",
        "note": "Catatan",
        "noNote": "—"
      },
      "form": {
        "title": "Saldo awal baru",
        "date": "Tanggal",
        "dateHint": "Saldo awal selalu bertanggal sama dengan tanggal mulai pakai.",
        "note": "Catatan (opsional)",
        "lines": "Baris",
        "pool": "Bahan",
        "selectPool": "Pilih bahan",
        "qty": "Jumlah",
        "costPerUnit": "Biaya per satuan (Rp)",
        "lineValue": "Nilai baris",
        "total": "Total nilai",
        "addLine": "Tambah baris",
        "removeLine": "Hapus baris",
        "noPools": "Belum ada stok bahan. Buat stok bahan dulu.",
        "goToPools": "Buka stok bahan",
        "required": "Wajib diisi.",
        "qtyInvalid": "Isi angka bulat lebih dari 0.",
        "costInvalid": "Isi angka bulat 0 atau lebih.",
        "duplicatePool": "Bahan ini sudah dipakai di baris lain.",
        "duplicateVariant": "Varian ini sudah dipakai di baris lain.",
        "save": "Simpan",
        "saving": "Menyimpan…",
        "cancel": "Batal",
        "created": "Saldo awal dicatat."
      },
      "wip": {
        "explanation": "Part yang sudah dicetak sebelum tanggal mulai pakai dan belum dirakit. Isi jumlahnya saja, tanpa nilai. Part yang lebih tua dari versi tidak kompatibel tidak dicatat di sini: hapuskan saja.",
        "product": "Produk",
        "model": "Model",
        "select": "Pilih",
        "currentVersion": "Versi terbaru: v{{version}}. Slot warna mengikuti versi ini.",
        "noCurrentVersion": "Model ini belum punya versi yang aktif.",
        "variant": "Varian (isian awal, opsional)",
        "noVariant": "Tanpa varian",
        "variantHint": "Mengisi filamen tiap slot warna dari warna varian. Pilihan tetap bisa diubah.",
        "slots": "Slot warna",
        "selectPool": "Pilih filamen",
        "qty": "Jumlah part",
        "duplicateItem": "Model dan warna ini sudah ada di baris lain.",
        "noProducts": "Belum ada produk dengan model. Buat produk dan modelnya dulu.",
        "goToProducts": "Buka produk"
      },
      "variant": {
        "explanation": "Barang jadi yang sudah ada di gudang atau di kanal penjualan saat tanggal mulai pakai. Isi jumlahnya saja, tanpa nilai.",
        "variant": "Varian",
        "select": "Pilih varian",
        "qty": "Jumlah (pcs)",
        "total_other": "Total {{count}} pcs",
        "noVariants": "Belum ada varian. Buat produk dan variannya dulu.",
        "noChannels": "Belum ada kanal penjualan.",
        "goToChannels": "Buka kanal penjualan"
      },
      "errors": {
        "adoptionDateNotSet": "Isi tanggal mulai pakai dulu di pengaturan workspace.",
        "notAdoptionDate": "Saldo awal harus bertanggal sama dengan tanggal mulai pakai ({{date}}).",
        "beforeAdoptionDate": "Tanggal tidak boleh sebelum tanggal mulai pakai.",
        "stockItemAlreadyMoved": "Bahan ini sudah punya mutasi stok, jadi saldo awalnya tidak bisa dicatat lagi.",
        "wipAlreadyMoved": "Part ini sudah punya mutasi stok di WIP, jadi saldo awalnya tidak bisa dicatat lagi.",
        "variantAlreadyMoved": "Varian ini sudah punya mutasi stok di lokasi ini, jadi saldo awalnya tidak bisa dicatat lagi.",
        "salesChannelArchived": "Channel ini sudah diarsipkan, jadi tidak bisa diberi saldo awal. Hanya koreksi yang mengurangi stoknya yang bisa dicatat.",
        "recipeSlotArchived": "Versi terbaru model ini memakai slot warna yang diarsipkan. Kembalikan slot itu dari arsip atau ubah resepnya.",
        "validationFailed": "Periksa lagi isian Anda.",
        "staleRecord": "Data sudah berubah. Muat ulang halaman, lalu coba lagi.",
        "forbidden": "Anda tidak punya akses untuk tindakan ini."
      }
    },
    "users": {
      "title": "Pengguna & undangan",
      "members": "Anggota",
      "invitations": "Undangan",
      "noInvitations": "Tidak ada undangan yang menunggu.",
      "you": "Anda",
      "deactivated": "Nonaktif",
      "expired": "Kedaluwarsa",
      "expires": "Berlaku sampai {{date}}",
      "invitedBy": "Diundang oleh {{name}}",
      "invitedAtSetup": "Undangan pertama saat workspace dibuat",
      "actionsFor": "Tindakan untuk {{name}}",
      "makeOwner": "Jadikan Pemilik",
      "makeStaff": "Jadikan Staf",
      "deactivate": "Nonaktifkan",
      "reactivate": "Aktifkan kembali",
      "resend": "Kirim ulang",
      "revoke": "Batalkan undangan",
      "confirm": "Lanjutkan",
      "cancel": "Batal",
      "working": "Memproses…",
      "confirmRoleTitle": "Jadikan {{name}} {{role}}?",
      "confirmRoleBody": "Peran {{name}} di workspace ini berubah menjadi {{role}}.",
      "confirmSelfDemoteTitle": "Jadikan diri Anda Staf?",
      "confirmSelfDemoteBody": "Anda akan kehilangan akses Pemilik: pengaturan dan pengelolaan pengguna tidak bisa Anda buka lagi. Hanya Pemilik lain yang bisa mengembalikannya.",
      "confirmDeactivateTitle": "Nonaktifkan keanggotaan {{name}}?",
      "confirmSelfDeactivateTitle": "Nonaktifkan keanggotaan Anda sendiri?",
      "confirmDeactivateBody": "{{name}} tidak bisa lagi membuka workspace ini. Keanggotaan bisa diaktifkan kembali kapan saja.",
      "confirmSelfDeactivateBody": "Anda tidak bisa lagi membuka workspace ini sampai Pemilik lain mengaktifkan kembali keanggotaan Anda.",
      "confirmReactivateTitle": "Aktifkan kembali keanggotaan {{name}}?",
      "confirmReactivateBody": "{{name}} bisa masuk lagi dengan peran {{role}}.",
      "confirmRevokeTitle": "Batalkan undangan untuk {{email}}?",
      "confirmRevokeBody": "Tautan undangan tidak berlaku lagi. Anda bisa mengundang email ini lagi nanti.",
      "roleChanged": "{{name}} sekarang {{role}}.",
      "deactivatedDone": "Keanggotaan {{name}} dinonaktifkan.",
      "reactivatedDone": "Keanggotaan {{name}} aktif kembali.",
      "invited": "Undangan dikirim ke {{email}}.",
      "resent": "Undangan dikirim ulang ke {{email}}.",
      "revoked": "Undangan untuk {{email}} dibatalkan.",
      "lastActiveOwner": "Workspace harus punya minimal satu Pemilik aktif.",
      "alreadyMember": "Email ini sudah jadi anggota workspace ini. Kalau keanggotaannya nonaktif, aktifkan kembali dari daftar anggota.",
      "notOwnerAnymore": "Anda tidak lagi punya akses Pemilik di workspace ini.",
      "invalidTransition": "Data sudah berubah. Daftar sudah dimuat ulang, silakan coba lagi.",
      "rateLimited": "Terlalu banyak undangan. Coba lagi nanti.",
      "invite": {
        "open": "Undang pengguna",
        "title": "Undang pengguna",
        "description": "Kami kirimkan tautan undangan yang berlaku 7 hari.",
        "emailLabel": "Email",
        "emailPlaceholder": "nama@contoh.com",
        "roleLabel": "Peran",
        "invalidEmail": "Masukkan alamat email yang benar.",
        "submit": "Kirim undangan",
        "submitting": "Mengirim…"
      },
      "list": {
        "invitedBy": "Pengundang",
        "expires": "Masa berlaku"
      }
    },
    "expenseCategories": {
      "title": "Kategori pengeluaran",
      "subtitle": "Daftar kategori yang bisa dipilih saat mencatat pengeluaran.",
      "nameLabel": "Nama kategori",
      "add": "Tambah kategori",
      "empty": "Belum ada kategori pengeluaran.",
      "reserved": "Belanja bahan",
      "reservedHint": "Kategori ini otomatis dipakai belanja bahan. Namanya tidak bisa diubah, dan kategorinya tidak bisa diarsipkan atau dihapus.",
      "archived": "Diarsipkan",
      "archivedHint": "Tidak muncul lagi saat mencatat pengeluaran baru. Pengeluaran lama tetap memakainya.",
      "used": "Sudah dipakai",
      "usedHint": "Sudah dipakai pengeluaran, jadi hanya bisa diarsipkan, tidak bisa dihapus.",
      "unusedHint": "Belum dipakai pengeluaran mana pun, jadi masih bisa dihapus.",
      "rename": "Ubah nama",
      "renameTitle": "Ubah nama kategori",
      "renameDescription": "Nama baru berlaku di semua pengeluaran yang memakai kategori ini, termasuk yang lama.",
      "archive": "Arsipkan",
      "unarchive": "Aktifkan lagi",
      "delete": "Hapus",
      "deleteTitle": "Hapus kategori ini?",
      "deleteDescription": "Kategori hilang dari daftar. Hanya kategori yang belum pernah dipakai yang bisa dihapus.",
      "deleteConfirm": "Hapus",
      "required": "Wajib diisi.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "cancel": "Batal",
      "errors": {
        "reserved": "Kategori belanja bahan tidak bisa diubah, diarsipkan, atau dihapus.",
        "inUse": "Kategori ini sudah dipakai pengeluaran. Arsipkan saja.",
        "nameTaken": "Nama kategori itu sudah dipakai.",
        "validationFailed": "Periksa lagi nama kategori. Nama itu mungkin sudah dipakai.",
        "alreadyChanged": "Status kategori ini sudah berubah. Muat ulang halaman.",
        "forbidden": "Anda tidak punya akses untuk tindakan ini."
      }
    },
    "listingBrand": {
      "title": "Merek listing marketplace",
      "explanation": "Merek yang tampil di listing setiap produk, misalnya \"Risal 3D\" atau \"No brand\".",
      "label": "Merek",
      "tooLong": "Maksimal 100 karakter.",
      "save": "Simpan merek",
      "saved": "Tersimpan"
    }
  },
  "uploads": {
    "errors": {
      "typeNotAllowed": "Jenis file ini tidak bisa diunggah. Pilih file .3mf, .stl, .png, .jpg atau .webp.",
      "tooLarge": "File kosong atau lebih dari 100 MB.",
      "rejected": "Isi file tidak cocok dengan jenis atau ukurannya, jadi file dihapus. Periksa filenya, lalu unggah lagi.",
      "forbidden": "Hanya Pemilik yang bisa mengunggah file.",
      "uploadFailed": "Unggah gagal. Periksa koneksi, lalu coba lagi.",
      "notFound": "File tidak ditemukan."
    }
  },
  "errors": {
    "generic": "Gangguan sementara. Coba lagi nanti.",
    "badRequest": "Data yang dikirim tidak lengkap atau tidak sesuai. Muat ulang halaman, lalu coba lagi.",
    "payloadTooLarge": "Terlalu banyak data dalam satu simpan. Simpan sebagian dulu, lalu lanjutkan.",
    "poolKindChanged": "Jenis stok bahan sudah berubah. Muat ulang halaman, lalu coba lagi.",
    "staleRecord": "Data ini sudah diubah orang lain, jadi isian Anda belum disimpan.",
    "staleRecordReload": "Muat versi terbaru"
  },
  "roles": {
    "owner": "Pemilik",
    "staff": "Staf"
  },
  "cogs": {
    "title": "HPP",
    "subtitle": "HPP per unit tiap varian, dihitung otomatis dari data batch cetak, bahan, mesin dan perakitan terbaru.",
    "empty": "Belum ada varian.",
    "archived": "Diarsipkan",
    "cogs": "HPP / unit",
    "estimated": "Estimasi",
    "batchesUsed": "Batch cetak dipakai",
    "computedAt": "Dihitung",
    "notComputable": "Belum bisa dihitung. Pastikan BOM, warna tiap slot, resep, tarif mesin dan pengaturan HPP sudah lengkap.",
    "vendorPrice": "Harga vendor saat ini",
    "noVendorPrice": "Belum ada harga",
    "suggestedPrice": "Saran harga vendor",
    "suggestedNoCogs": "HPP belum bisa dihitung.",
    "suggestedNoMargin": "Margin target belum diatur di Pengaturan HPP.",
    "suggestedHint": "Hanya saran: HPP ÷ (1 − margin target), dibulatkan ke atas ke Rp 1.000.",
    "settings": {
      "title": "Pengaturan HPP",
      "explanation": "Angka dasar untuk menghitung HPP per varian. Setiap perubahan langsung dipakai untuk semua HPP berikutnya. Kosongkan yang belum diketahui; HPP baru dihitung setelah angka yang dibutuhkan terisi.",
      "laborRate": "Tarif tenaga kerja / jam (Rp)",
      "laborRateHint": "Satu tarif per jam untuk semua orang.",
      "electricityPrice": "Harga listrik / kWh (Rp)",
      "electricityPriceHint": "Dipakai untuk biaya listrik di tarif mesin.",
      "maintenance": "Biaya perawatan (%)",
      "maintenanceHint": "Tambahan di atas penyusutan dan listrik tarif mesin. Satu nilai untuk semua mesin.",
      "targetMargin": "Margin target (%)",
      "targetMarginHint": "Dipakai untuk harga vendor yang disarankan. Harus di bawah 100%. Produk bisa punya margin target sendiri.",
      "defaultYield": "Yield default (%)",
      "defaultYieldHint": "Dipakai untuk perkiraan HPP selama data batch cetak belum cukup. Lebih dari 0% sampai 100%.",
      "wholeInvalid": "Isi angka bulat 0 atau lebih.",
      "percentInvalid": "Isi persen 0 atau lebih, paling banyak dua angka di belakang koma.",
      "marginInvalid": "Isi persen 0 sampai di bawah 100, paling banyak dua angka di belakang koma.",
      "yieldInvalid": "Isi persen lebih dari 0 sampai 100, paling banyak dua angka di belakang koma.",
      "invalid": "Periksa lagi isian Anda.",
      "save": "Simpan",
      "saving": "Menyimpan…",
      "saved": "Pengaturan HPP disimpan."
    },
    "breakdown": {
      "title": "Rincian HPP",
      "back": "Kembali ke HPP",
      "open": "Lihat rincian",
      "total": "HPP / unit",
      "computedAt": "Dihitung {{at}}",
      "autoRecompute": "Dihitung ulang otomatis setiap ada perubahan data batch cetak, bahan, mesin, BOM atau perakitan.",
      "bomFrom": "BOM berlaku sejak {{date}}",
      "lines": "Rincian per bagian",
      "material": "Bahan {{model}} · slot {{slot}}",
      "materialMath": "{{grams}} g per part baik × Rp {{costPerGram}} / g ({{pool}})",
      "machine": "Mesin {{model}}",
      "machineMath": "{{hours}} jam per part baik × tarif mesin Rp {{rate}} / jam",
      "component": "Komponen {{name}}",
      "componentMath": "{{qty}} × Rp {{cost}} / pcs",
      "labor": "Tenaga kerja",
      "laborMath": "{{minutes}} menit per unit × Rp {{rate}} / jam",
      "laborWindow": "Dari {{count}} perakitan terakhir: {{minutes}} menit untuk {{units}} unit",
      "laborDefault": "Memakai menit kerja default produk (belum ada perakitan)",
      "qty": "× {{qty}} per unit (BOM)",
      "rounding": "Pembulatan",
      "roundingHint": "Tiap baris dibulatkan sendiri; baris ini membuat jumlahnya sama dengan HPP.",
      "window": "Data dipakai",
      "windowPart": "{{model}} · versi terbaru v{{version}}",
      "windowStats": "{{batches}} batch cetak terakhir dari semua versi model, {{ok}} part baik dari {{printed}} dicetak",
      "yield": "Yield di data ini: {{percent}}",
      "yieldNote": "Yield hanya info: biaya sudah dihitung per part baik, jadi tidak dibagi yield lagi. Yield di halaman produk memakai semua batch cetak, jadi angkanya bisa beda.",
      "batches": "Batch cetak di data ini",
      "batchRow": "v{{version}} · {{ok}}/{{printed}} baik · {{grams}} g · {{minutes}} menit · {{machine}}",
      "estimatedReasons": {
        "fewer_batches": "Estimasi: kurang dari 3 batch cetak",
        "zero_ok": "Estimasi: belum ada part baik di batch cetak",
        "labor_default": "Estimasi: tenaga kerja dari menit default produk"
      },
      "estimateInputs": "Dihitung dari resep: {{parts}} part per plate, {{minutes}} menit per plate, yield default {{yield}}, rata-rata tarif mesin Rp {{rate}} / jam",
      "gramsPerPlate": "{{grams}} g per plate (resep)",
      "notComputable": "Belum bisa dihitung. Pastikan BOM, warna tiap slot, resep, tarif mesin dan pengaturan HPP sudah lengkap.",
      "variantBlock": "HPP",
      "productTab": "Ringkasan HPP",
      "productEmpty": "Produk ini belum punya varian."
    }
  },
  "account": {
    "title": "Akun",
    "profile": {
      "title": "Profil",
      "name": "Nama",
      "nameHint": "Tampil di semua workspace. Kosongkan untuk memakai email.",
      "nameTooLong": "Nama paling banyak 100 karakter.",
      "email": "Email",
      "save": "Simpan nama",
      "saving": "Menyimpan…",
      "saved": "Nama tersimpan.",
      "invalid": "Periksa lagi nama Anda."
    },
    "signInMethods": {
      "title": "Cara masuk",
      "magicLink": "Tautan masuk lewat email",
      "active": "Aktif",
      "google": "Google",
      "linked": "Tersambung",
      "notLinked": "Belum tersambung",
      "googleHint": "Pilih \"Masuk dengan Google\" di halaman masuk dengan akun Google yang emailnya sama."
    },
    "sessions": {
      "title": "Sesi aktif",
      "description": "Perangkat yang sedang masuk ke akun Anda.",
      "current": "Perangkat ini",
      "unknownDevice": "Perangkat tidak dikenal",
      "details": "IP {{ip}} · terakhir aktif {{lastSeen}}",
      "logOutOthers": "Keluar dari perangkat lain",
      "confirmTitle": "Keluar dari perangkat lain?",
      "confirmBody": "Semua perangkat lain akan keluar dari akun Anda. Perangkat ini tetap masuk.",
      "cancel": "Batal",
      "othersLoggedOut": "Perangkat lain sudah dikeluarkan."
    },
    "connectedApps": {
      "title": "Aplikasi AI terhubung",
      "description": "Aplikasi seperti ChatGPT atau Claude yang Anda izinkan membaca katalog dan membuat Produk. Hanya Owner yang bisa menghubungkan.",
      "serverUrl": "Alamat server MCP (tempel di aplikasi AI)",
      "empty": "Belum ada aplikasi yang terhubung.",
      "details": "Workspace {{workspace}} · terhubung {{connectedAt}}",
      "revoke": "Putuskan",
      "confirmTitle": "Putuskan {{name}}?",
      "confirmBody": "{{name}} tidak bisa lagi mengakses Tridi. Untuk memakainya lagi, hubungkan ulang dari aplikasi tersebut."
    }
  },
  "demo": {
    "badge": "Demo",
    "reset": {
      "title": "Workspace demo",
      "explanation": "Workspace ini berisi data contoh untuk dicoba. Atur ulang untuk memulai lagi dari data contoh awal.",
      "button": "Atur ulang demo",
      "resetting": "Mengatur ulang…",
      "confirmTitle": "Atur ulang workspace demo?",
      "confirmBody": "Semua perubahan Anda di workspace demo ini akan diganti dengan data contoh awal. Workspace asli Anda tidak terpengaruh.",
      "confirm": "Atur ulang",
      "cancel": "Batal"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Selamat datang di Tridi",
      "intro": "Dua hal dulu sebelum mulai: pilih cara memulai, lalu isi tanggal mulai pakai.",
      "trackLegend": "Bagaimana Anda mulai?",
      "tracks": {
        "from_scratch": {
          "title": "Mulai dari nol",
          "body": "Belum ada stok; mulai dari belanja bahan dan batch cetak pertama."
        },
        "existing_stock": {
          "title": "Bawa stok yang sudah ada",
          "body": "Sudah punya filamen, part, atau barang jadi; catat sebagai saldo awal."
        }
      },
      "trackRequired": "Pilih salah satu cara memulai.",
      "adoptionLabel": "Tanggal mulai pakai",
      "adoptionHint": "Hari ini atau sebelumnya. Tidak ada catatan yang boleh bertanggal sebelum tanggal ini.",
      "adoptionHintExistingStock": "Untuk stok yang sudah ada, ini tanggal saat hitungan stok Anda berlaku.",
      "adoptionRequired": "Isi tanggal mulai pakai.",
      "adoptionLocked": "Tanggal ini terkunci karena sudah ada catatan yang diposting.",
      "inFuture": "Tanggal tidak boleh setelah hari ini.",
      "start": "Mulai",
      "starting": "Menyimpan…"
    },
    "checklist": {
      "title": "Daftar persiapan",
      "intro": "Langkah dari workspace kosong sampai HPP pertama. Tanda selesai terisi sendiri dari data Anda.",
      "staffIntro": "Langkah persiapan yang bisa Anda kerjakan. Tanda selesai terisi sendiri dari data workspace.",
      "track": "Jalur: {{track}}",
      "changeTrack": "Ubah jalur",
      "progress": "{{done}} dari {{total}} selesai",
      "open": "Buka",
      "done": "Selesai",
      "notDone": "Belum",
      "hide": "Sembunyikan",
      "waitingOwner": "Menunggu Pemilik menyelesaikan persiapan",
      "waitingOwnerBody": "Langkah berikutnya hanya bisa dikerjakan Pemilik.",
      "cogsMissing": {
        "label": "Belum diisi: {{fields}}.",
        "labor_rate_per_hour": "tarif tenaga kerja",
        "electricity_price_per_kwh": "harga listrik",
        "machine_rate": "mesin aktif dengan harga beli, umur pakai, dan daya (watt)"
      },
      "costWarning": "Isi biaya stok bahan sebelum batch cetak pertama: batch dari stok bahan tanpa biaya tercatat Rp 0 dan HPP terlihat terlalu rendah.",
      "steps": {
        "track_and_adoption": {
          "title": "Pilih jalur dan tanggal mulai pakai",
          "why": "Tanggal mulai pakai menjadi awal catatan resmi; tidak ada catatan yang boleh bertanggal sebelumnya."
        },
        "pools": {
          "title": "Buat stok bahan",
          "why": "Setiap filamen dan komponen dicatat sebagai stok bahan sebelum bisa dipakai cetak atau dirakit."
        },
        "pool_cost": {
          "title": "Isi biaya stok bahan",
          "why": "Batch cetak mengambil biaya rata-rata stok bahan; tanpa biaya, HPP terlihat terlalu rendah."
        },
        "machine": {
          "title": "Tambah mesin",
          "why": "Batch cetak berjalan di sebuah mesin, dan tarif mesin masuk ke HPP."
        },
        "product_model": {
          "title": "Buat produk dan modelnya",
          "why": "Produk adalah barang yang dijual; model adalah part yang dicetak untuknya."
        },
        "model_version": {
          "title": "Unggah versi model dengan resep",
          "why": "Batch cetak hanya bisa memakai versi model yang punya file .3mf atau .stl dan resep cetak."
        },
        "bom": {
          "title": "Atur daftar bahan (BOM)",
          "why": "BOM menentukan part dan komponen yang dipakai satu unit barang jadi."
        },
        "variant": {
          "title": "Buat varian",
          "why": "Varian memetakan tiap slot warna ke stok bahan; stok dan HPP dihitung per varian."
        },
        "opening_stock": {
          "title": "Catat part dan barang jadi yang sudah ada",
          "why": "Part belum dirakit dan barang jadi yang sudah Anda punya dicatat sebagai saldo awal."
        },
        "batch": {
          "title": "Catat batch cetak pertama",
          "why": "Part yang berhasil dicetak masuk ke stok part belum dirakit."
        },
        "assembly": {
          "title": "Catat perakitan pertama",
          "why": "Perakitan mengubah part dan komponen menjadi barang jadi."
        },
        "sales_channel": {
          "title": "Tambah kanal penjualan",
          "why": "Kanal adalah tempat barang dititipkan atau dijual."
        },
        "dispatch": {
          "title": "Kirim barang pertama ke kanal",
          "why": "Pengiriman memindahkan barang jadi dari rumah ke stok kanal."
        },
        "sales_report": {
          "title": "Catat laporan penjualan pertama",
          "why": "Laporan penjualan mengurangi stok kanal dan mencatat uang yang akan diterima."
        },
        "cogs_settings": {
          "title": "Isi pengaturan HPP",
          "why": "Tarif tenaga kerja, harga listrik, dan tarif mesin dibutuhkan untuk menghitung HPP. Biaya perawatan boleh kosong (dihitung 0)."
        }
      }
    }
  },
  "searchCombobox": {
    "empty": "Tidak ditemukan.",
    "product": {
      "placeholder": "Pilih produk",
      "search": "Cari kode atau nama produk…"
    },
    "variant": {
      "placeholder": "Pilih varian",
      "search": "Cari SKU atau nama varian…"
    }
  },
  "catalog": {
    "choose": "Pilih…",
    "other": "Lainnya (ketik sendiri)",
    "none": "Tidak diisi",
    "unbranded": "{{name}} (tanpa merek)"
  },
  "filterBar": {
    "add": "Filter",
    "search": "Filter berdasarkan…",
    "noMatch": "Tidak ada yang cocok.",
    "date": "Tanggal",
    "from": "Dari tanggal",
    "to": "Sampai tanggal",
    "since": "Sejak {{date}}",
    "until": "Sampai {{date}}",
    "remove": "Hapus filter {{field}}",
    "clearAll": "Hapus semua",
    "presets": {
      "today": "Hari ini",
      "last7": "7 hari terakhir",
      "last30": "30 hari terakhir",
      "thisMonth": "Bulan ini"
    },
    "archived": "Diarsipkan",
    "shown": "Ditampilkan"
  },
  "landing": {
    "demos": {
      "BerandaDemo": "Tridi di HP: Beranda dengan dua printer. Batch B-0142 di Bambu P1S A mencapai 100% dan diselesaikan, lalu Gantungan Naga Merah yang bisa dirakit naik dari 6 ke 18 dan filamen PLA+ Merah masuk daftar stok bahan di bawah minimum.",
      "BatchDemo": "Menyelesaikan batch B-0142 dari HP: part OK diubah dari 13 ke 12, part gagal terisi 1 dengan alasan adhesion, gram filamen sudah terisi dari perkiraan, lalu Selesaikan ditekan.",
      "StockDemo": "Mencari naga merah di halaman Barang jadi: stok Gantungan Naga Merah muncul per lokasi, Gudang 86, Toko Mainan Sinar 12, Kado Kita 25 dan Hobi Corner 4, total 127.",
      "RolesDemo": "Menu Tridi untuk Pemilik lalu untuk Staf: Staf tidak melihat menu uang milik pemilik, seperti piutang kanal, harga jual ke kanal, ringkasan bulanan dan pengaturan."
    }
  },
  "productSetup": {
    "newTitle": "Produk baru",
    "back": "Kembali ke daftar produk",
    "toHub": "Kembali ke produk",
    "stepOf": "Langkah {{n}} dari {{total}}",
    "steps": {
      "product": "Produk",
      "models": "Bagian cetak",
      "variants": "Varian warna",
      "bom": "Daftar bahan",
      "done": "Selesai"
    },
    "next": "Lanjut",
    "previous": "Kembali",
    "saving": "Menyimpan…",
    "cancel": "Batal",
    "required": "Wajib diisi.",
    "wholeNumber": "Isi bilangan bulat lebih dari 0.",
    "product": {
      "title": "Produk apa yang mau dibuat?",
      "lead": "Cukup nama dan kode dulu. Biaya tenaga kerja dan margin bisa diatur nanti.",
      "name": "Nama produk",
      "namePlaceholder": "Contoh: Gantungan kunci kucing",
      "code": "Kode",
      "codeHint": "Diisi otomatis dari nama, boleh diganti. Huruf A–Z, angka dan tanda -, paling banyak 10 karakter. Dipakai di awal SKU.",
      "codeInvalid": "Pakai huruf A–Z, angka 0–9 atau tanda -, paling banyak 10 karakter.",
      "create": "Buat produk dan lanjut",
      "save": "Simpan dan lanjut"
    },
    "models": {
      "title": "Bagian apa saja yang dicetak?",
      "lead": "Satu model = satu bagian yang dicetak terpisah, misalnya badan dan tutup. Setiap model punya slot warna dan resep cetak.",
      "add": "Tambah model",
      "addAnother": "Tambah model lain",
      "newTitle": "Model baru",
      "name": "Nama bagian",
      "namePlaceholder": "Contoh: Badan",
      "slots": "Slot warna",
      "slotsHint": "Satu slot untuk setiap warna berbeda di bagian ini, misalnya utama dan mata.",
      "slotPlaceholder": "Contoh: utama",
      "addSlot": "Tambah slot",
      "removeSlot": "Buang slot {{label}}",
      "slotLimit": "Paling banyak {{max}} slot warna per model.",
      "recipe": "Resep cetak",
      "recipeHint": "Angka perkiraan dari slicer, per satu pelat. Dipakai untuk HPP sebelum ada batch cetak.",
      "partsPerPlate": "Part per pelat",
      "minutesPerPlate": "Menit cetak per pelat",
      "gramsPerPlate": "Gram per pelat",
      "gramsFor": "Gram {{label}} per pelat",
      "gramsRequired": "Isi gram untuk minimal satu slot.",
      "files": "File cetak (boleh nanti)",
      "save": "Simpan model",
      "noRecipe": "Belum ada resep cetak",
      "addRecipe": "Isi resep",
      "editRecipe": "Ubah resep",
      "editModel": "Ubah nama & slot",
      "recipeTitle": "Resep {{name}}",
      "noFiles": "Belum ada file .3mf / .stl",
      "filesCount": "{{count}} file",
      "versionLine": "v{{no}} · {{parts}} part/pelat · {{minutes}} menit",
      "needOne": "Tambahkan minimal satu model untuk lanjut.",
      "savedWithoutRecipe": "Model {{name}} tersimpan, tapi resepnya belum. Isi lagi lewat Isi resep.",
      "filesFailed": "Model tersimpan, tapi sebagian file gagal. Tambahkan lagi dari halaman versinya.",
      "slotName": "Nama slot"
    },
    "variants": {
      "title": "Warna apa saja yang dijual?",
      "lead": "Satu varian = satu pilihan warna yang dijual. Pilih satu filamen untuk semua slot, lalu ganti slot yang warnanya beda.",
      "add": "Tambah varian",
      "newTitle": "Varian baru",
      "editTitle": "Ubah {{name}}",
      "mainColor": "Warna utama",
      "mainColorHint": "Mengisi semua slot sekaligus.",
      "pickFilament": "Pilih filamen",
      "slotsTitle": "Per slot",
      "change": "Ganti",
      "same": "Sama dengan warna utama",
      "name": "Nama varian",
      "namePlaceholder": "Contoh: Merah",
      "sku": "SKU",
      "skuHint": "Diisi otomatis dari kode dan nama.",
      "save": "Simpan varian",
      "edit": "Ubah",
      "noFilaments": "Belum ada stok bahan filamen. Tambahkan dulu di Bahan.",
      "addFilament": "Tambah filamen",
      "noModels": "Tambahkan model dulu agar ada slot warna.",
      "needOne": "Tambahkan minimal satu varian untuk lanjut.",
      "needsColor": "Perlu warna"
    },
    "bom": {
      "title": "Apa saja yang dirakit jadi 1 unit?",
      "lead": "Daftar bahan dipakai untuk stok dan HPP: berapa bagian cetak dan komponen lain untuk satu unit produk.",
      "printed": "Bagian cetak",
      "components": "Komponen lain",
      "componentsHint": "Misalnya magnet, ring gantungan, kemasan.",
      "addComponent": "Tambah komponen",
      "pickComponent": "Pilih komponen",
      "noComponents": "Belum ada komponen di Bahan.",
      "remove": "Buang {{name}}",
      "decrease": "Kurangi {{name}}",
      "increase": "Tambah {{name}}",
      "qtyOf": "Jumlah {{name}} per unit",
      "effectiveToday": "Berlaku mulai hari ini",
      "effectiveOn": "Berlaku mulai {{date}}",
      "changeDate": "Ubah",
      "date": "Berlaku mulai",
      "lockNote": "Setelah disimpan, daftar bahan yang sudah berlaku terkunci. Perubahan nanti dibuat sebagai versi baru.",
      "save": "Simpan daftar bahan",
      "saveAndFinish": "Simpan dan selesai",
      "locked": "Daftar bahan sudah berlaku dan terkunci.",
      "newVersion": "Buat versi baru",
      "needModel": "Tambahkan model dulu di langkah Bagian cetak.",
      "skip": "Lanjut tanpa mengubah"
    },
    "done": {
      "title": "{{name}} siap",
      "lead": "Ini ringkasan yang sudah diatur. Semua bisa diubah lagi dari halaman produk.",
      "models": "{{count}} model",
      "variants": "{{count}} varian",
      "bomLines": "{{count}} baris daftar bahan",
      "cogs": "Perkiraan HPP per unit",
      "cogsHint": "Dihitung dari resep cetak sampai ada batch cetak nyata.",
      "activate": "Aktifkan produk",
      "activateHint": "Tandai produk ini sudah dijual. Bisa diubah kapan saja.",
      "missing": "Yang belum lengkap",
      "startBatch": "Mulai cetak",
      "openProduct": "Lihat produk",
      "laborMinutes": "Menit kerja per unit",
      "laborMinutesHint": "Berapa menit untuk merakit dan menyelesaikan 1 unit? HPP memakai angka ini sampai ada perakitan nyata.",
      "laborMinutesSave": "Simpan"
    },
    "sheet": {
      "title": "Lembar rakit",
      "lead": "Yang sedang dibuat",
      "empty": "Belum ada isi.",
      "unnamed": "Produk tanpa nama",
      "noModels": "Belum ada bagian cetak",
      "noVariants": "Belum ada varian",
      "noBom": "Daftar bahan belum diisi",
      "perUnit": "per unit",
      "show": "Lihat lembar rakit",
      "recipe": "{{grams}} g · {{minutes}} menit untuk {{parts}} part"
    },
    "hub": {
      "progress": "Kelengkapan produk",
      "check": {
        "models": "Model",
        "versions": "Resep cetak",
        "variants": "Varian",
        "bom": "Daftar bahan"
      },
      "complete": "Lengkap",
      "missing": "Belum",
      "finish": "Lengkapi",
      "modelsTitle": "Bagian cetak",
      "variantsTitle": "Varian warna",
      "bomTitle": "Daftar bahan",
      "costTitle": "Biaya",
      "cogsTitle": "HPP per varian",
      "edit": "Ubah",
      "editProduct": "Ubah produk",
      "noBom": "Belum ada daftar bahan. Tanpa ini produk belum bisa dirakit.",
      "upcoming": "Versi berikutnya berlaku mulai {{date}}",
      "allVersions": "Semua versi",
      "yield": "{{percent}}% berhasil",
      "openModel": "Buka {{name}}",
      "listingTitle": "Listing marketplace"
    }
  }
}
